<template>
  <div>
    <v-container fluid style="padding: 0px 16px 0 16px; margin-top: 0px;">
      <v-row style="margin-top: 0px;  ">
        <v-col cols="12">
          <div class="modelclass">
            Model {{ (ModelFirst == "" ? "-" : ModelFirst) }} : {{
              (TopicName == "" ? "-" : TopicName) }}
          </div>
        </v-col>
      </v-row>
      <v-row class="w-fill-available h-fill-available" style="padding-right: 12px;margin-top: 0px;">
        <v-col v-if="SetPopup" class="h-fill-available" style="max-width: 300px;background-color: white; margin: 0px 0px 25px 12px!important;
              border-radius: 12px; padding: 0px; flex: none;
              overflow-y: auto; max-height: calc(-244px + 100vh);height: calc(-244px + 100vh) !important;">

          <div class="tool-box">
            <v-row style="margin: 0px;padding: 0px;display: flex;align-items: center;">
              <v-col class="titlediv">
                <span class="labeldiv" aria-hidden="true"><v-img :src="images.parameterImg" alt="parameters" width="25"
                    height="25"></v-img>
                  Parameters</span>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col cols="12" class="px-6">
                <div class="stream-param-box">
                  <div class="stream-field-row">
                    <span>
                      <label class="stream-label" for="user-id-stream">{{ $t('userIdLabel') }}</label>
                    </span>

                    <v-text-field id="user-id-stream" class="stream-text-field modern-input" variant="outlined"
                      density="comfortable" hide-details v-model="User_Id_Show" :placeholder="$t('enterUserId')" />
                  </div>
                  <div class="stream-field-row">
                    <span>
                      <label class="stream-label" for="time-delay-stream">{{ $t('timeDelay') }}</label>
                    </span>
                    <v-text-field id="time-delay-stream" class="stream-text-field modern-input" variant="outlined"
                      density="comfortable" hide-details v-model="Time_Delay" placeholder="ms" type="number" min="0"
                      @keypress="blockNegative" />
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- Log -->
          <div class="tool-box">
            <v-row style="margin: 0px;padding: 0px;display: flex;align-items: center;">
              <v-col class="titlediv">
                <span class="labeldiv" aria-hidden="true"><v-img :src="images.logImg" alt="parameters" width="25"
                    height="25"></v-img>
                  Log</span>
                <div class="d-flex justify-end">
                  <v-btn v-if="LOG_STATUS == false" v-on:click="LOG_STATUS = true"
                    @keydown.enter.prevent="LOG_STATUS = true" @keydown.space.prevent="LOG_STATUS = true" variant="text"
                    class="log-toggle-button" icon style="cursor: pointer;">
                    <v-icon size="23">mdi-menu-down</v-icon> </v-btn>
                  <v-btn v-else v-on:click="LOG_STATUS = false" @keydown.enter.prevent="LOG_STATUS = false"
                    @keydown.space.prevent="LOG_STATUS = false" class="log-toggle-button" variant="text" icon
                    style="cursor: pointer;">
                    <v-icon size="23">mdi-menu-up</v-icon> </v-btn>
                </div>
              </v-col>
            </v-row>
            <div v-if="LOG_STATUS == true" class="mx-5">
              <!-- prompt -->
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 14px;" for="DataLog-Prompt-textarea-stream">{{ $t('systemMessage') }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-Prompt-textarea-stream" class="Log_text_textarea" v-model="DataLog.Prompt"
                    variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>

              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 14px;" for="DataLog-Vector-textarea-stream">{{ $t('knowledge') }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-Vector-textarea-stream" class="Log_text_textarea" v-model="DataLog.Vector"
                    variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>

              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 14px;" for="DataLog-ReplySQL-textarea-stream">{{ $t('sqlQuery') }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-ReplySQL-textarea-stream" class="Log_text_textarea" v-model="DataLog.ReplySQL"
                    variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>

              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 14px;" for="DataLog-ReplyDataSelect-textarea-stream">{{ $t('sqlQueryResult')
                  }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-ReplyDataSelect-textarea-stream" class="Log_text_textarea"
                    v-model="DataLog.ReplyDataSelect" variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 14px;" for="DataLog-FlowActionIntent-textarea-stream">{{ $t('workFlow')
                  }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-FlowActionIntent-textarea-stream" class="Log_text_textarea"
                    v-model="DataLog.FlowActionIntent" variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>

              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 14px;" for="DataLog-Memory-textarea-stream">{{ $t('memory') }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">

                <v-col style=" padding-top: 0px;">

                  <v-textarea id="DataLog-Memory-textarea-stream" class="Log_text_textarea" v-model="DataLog.Memory"
                    variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>


              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <span style="font-size: 14px;font-weight: bold;" aria-hidden="true">{{ $t('llmsModel') }}</span>
                </v-col>
              </v-row>
              <div class="modeldiv">
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">ModelID : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.ModelID }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">ModelName : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.ModelName }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Provider : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.Provider }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Model : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.Model }}</span></span>
                  </v-col>
                </v-row>

                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 14px;" for="DataLog-GPT_Model-promptTemplate-stream">{{ $t('systemMessage')
                    }}</label>
                    <v-textarea id="DataLog-GPT_Model-promptTemplate-stream" class="Log_text_textarea"
                      v-model="DataLog.GPT_Model.promptTemplate" variant="outlined" readonly rows="2"></v-textarea>
                  </v-col>
                </v-row>

                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 14px;" for="DataLog-GPT_Model-vectordbName-stream">{{
                      $t('knowledgeDocuments') }}</label>
                    <v-textarea id="DataLog-GPT_Model-vectordbName-stream" class="Log_text_textarea"
                      v-model="DataLog.GPT_Model.vectordbName" variant="outlined" readonly rows="2"></v-textarea>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Extension : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.Extension }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Description : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.Description }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Gender : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.gender }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">TopN_Chunks : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.TopVDB }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Internet : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.internet }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Feedback : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.feedback }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">HistoryCount : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.HistoryCount }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">HistoryMinute : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.HistoryMinute }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Temperature : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.temperature }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Top_P : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.top_p }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Frequency_Penalty : <span
                        style="font-weight:bold;">{{ DataLog.GPT_Model.frequency_penalty }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Presence_Penalty : <span
                        style="font-weight:bold;">{{ DataLog.GPT_Model.presence_penalty }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">Stop_Sequence : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.Stop }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">MaxTokensResponse : <span
                        style="font-weight:bold;">{{ DataLog.GPT_Model.max_tokens }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">IsStream : <span style="font-weight:bold;">{{
                      DataLog.GPT_Model.IsStream }}</span></span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 14px;" for="DataLog-GPT_Model-EndpointURL-stream">{{ $t('endpoint')
                    }}</label>
                    <v-textarea id="DataLog-GPT_Model-EndpointURL-stream" class="Log_text_textarea"
                      v-model="DataLog.GPT_Model.EndpointURL" variant="outlined" readonly rows="2"></v-textarea>
                  </v-col>
                </v-row>
                <v-row v-if="DataLog.AiAttempts && DataLog.AiAttempts.length > 0" style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">
                      Priority : <span style="font-weight:bold;">{{ DataLog.AiAttempts[DataLog.AiAttempts.length -
                        1]?.PriorityDisplay ?? "-" }}</span>
                      <template v-if="DataLog.AiAttempts.length > 1">
                        <span style="color: #ff9800; margin-left: 8px;">
                          Failover ({{ DataLog.AiAttempts.length - 1 }}x)
                        </span>
                      </template>
                    </span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">{{ $t('UserQuery') }} : {{ DataLog.TextVector
                    }}</span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">{{ $t('OrgVectorSearch') }} : {{ DataLog.Text
                    }}</span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <span style="font-size: 12px;" aria-hidden="true">{{ $t('ModVectorSearch') }} : {{ DataLog.Translate
                      ?? "-"
                    }}</span>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;" for="DataLog-GPT_Model-VectorCoise-stream">{{ $t('vectorCosine')
                    }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style=" padding-top: 0px;">
                    <v-textarea id="DataLog-GPT_Model-VectorCoise-stream" class="Log_text_textarea"
                      v-model="DataLog.VectorCoise" variant="outlined" readonly rows="2"></v-textarea>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;" for="DataLog-GPT_Model-Private_Memory-stream">{{ $t('privateMemory')
                    }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">

                  <v-col style=" padding-top: 0px;">

                    <v-textarea id="DataLog-GPT_Model-Private_Memory-stream" class="Log_text_textarea"
                      v-model="DataLog.Private_Memory" variant="outlined" readonly rows="2"></v-textarea>
                  </v-col>
                </v-row>
              </div>

              <!-- AiAttempts -->
              <v-row style="margin-top: 0px;display: flex;align-items: center;">
                <v-col style="margin-top: 0px;display: flex;align-items: center;justify-content: space-between;">
                  <span style="font-size: 14px;font-weight: bold;" aria-hidden="true">{{ $t('aiAttempts') }}</span>
                  <div class="d-flex justify-end">
                    <v-btn v-if="AI_ATTEMPTS_STATUS == false" v-on:click="AI_ATTEMPTS_STATUS = true"
                      @keydown.enter.prevent="AI_ATTEMPTS_STATUS = true"
                      @keydown.space.prevent="AI_ATTEMPTS_STATUS = true" variant="text" class="log-toggle-button" icon
                      style="cursor: pointer;">
                      <v-icon size="23">mdi-menu-down</v-icon> </v-btn>
                    <v-btn v-else v-on:click="AI_ATTEMPTS_STATUS = false"
                      @keydown.enter.prevent="AI_ATTEMPTS_STATUS = false"
                      @keydown.space.prevent="AI_ATTEMPTS_STATUS = false" class="log-toggle-button" variant="text" icon
                      style="cursor: pointer;">
                      <v-icon size="23">mdi-menu-up</v-icon> </v-btn>
                  </div>
                </v-col>
              </v-row>
              <div v-if="AI_ATTEMPTS_STATUS">
                <div v-if="DataLog.AiAttempts && DataLog.AiAttempts.length > 0">
                  <div v-for="(attempt, idx) in DataLog.AiAttempts" :key="idx" class="modeldiv"
                    style="margin-bottom: 8px;">
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 13px;font-weight: bold;" aria-hidden="true">
                          #{{ attempt.AttemptOrder }}
                          <span :style="attempt.Success ? 'color: green;' : 'color: red;'">
                            {{ attempt.Success ? '✔ Success' : '✘ Failed' }}
                          </span>
                          <span v-if="attempt.IsRetry" style="color: #ff9800; margin-left: 4px;">(Retry)</span>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;" aria-hidden="true">Provider : <span style="font-weight:bold;">{{
                          attempt.Provider }}</span></span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;" aria-hidden="true">ModelName : <span style="font-weight:bold;">{{
                          attempt.ModelName }}</span></span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <label style="font-size: 12px;" :for="'DataLog-AiAttempt-EndpointUrl-' + idx">{{
                          $t('endpointUrl') }}</label>
                        <v-textarea :id="'DataLog-AiAttempt-EndpointUrl-' + idx" class="Log_text_textarea"
                          :model-value="attempt.EndpointUrl" variant="outlined" readonly rows="2"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;" aria-hidden="true">EndpointId : <span
                            style="font-weight:bold;">{{
                              attempt.EndpointId }}</span></span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;" aria-hidden="true">Priority : <span style="font-weight:bold;">{{
                          attempt.PriorityDisplay }}</span></span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;" aria-hidden="true">ResponseTime : <span
                            style="font-weight:bold;">{{
                              attempt.ResponseTimeMs != null ? attempt.ResponseTimeMs.toFixed(2) + ' ms' : '-'
                            }}</span></span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;" aria-hidden="true">Timestamp : <span style="font-weight:bold;">{{
                          attempt.TimestampUtc }}</span></span>
                      </v-col>
                    </v-row>
                    <v-row v-if="attempt.ReplyPreview" style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;" aria-hidden="true">ReplyPreview : <span
                            style="font-weight:bold;">{{
                              attempt.ReplyPreview }}</span></span>
                      </v-col>
                    </v-row>
                    <v-row v-if="attempt.ErrorMessage" style="margin-top: 0px;">
                      <v-col style="margin-top: 0px; padding-top: 0px;">
                        <label style="font-size: 12px;" :for="'DataLog-AiAttempt-Error-' + idx">{{ $t('error')
                        }}</label>
                        <v-textarea :id="'DataLog-AiAttempt-Error-' + idx" class="Log_text_textarea"
                          :model-value="attempt.ErrorMessage" variant="outlined" readonly rows="2"></v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <div v-else>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px; color: #999;" aria-hidden="true">{{ $t('noAiAttemptsData') }}</span>
                    </v-col>
                  </v-row>
                </div>
              </div>

            </div>
          </div>
          <!-- Topic list -->
          <div class="tool-box" style="overflow-y: hidden;">
            <v-row style="margin: 0px; padding: 0px;display: flex;align-items: center;">
              <v-col class="titlediv">
                <span class="labeldiv" aria-hidden="true"><v-img :src="images.chatImg" alt="parameters" width="25"
                    height="25"></v-img>
                  Chats</span>
                <div class="d-flex justify-end">
                  <v-btn v-if="Topic_STATUS == false" v-on:click="Topic_STATUS = true"
                    @keydown.enter.prevent="Topic_STATUS = true" @keydown.space.prevent="Topic_STATUS = true"
                    variant="text" class="log-toggle-button" icon style="cursor: pointer;">
                    <v-icon size="23">mdi-menu-down</v-icon> </v-btn>
                  <v-btn v-else v-on:click="Topic_STATUS = false" @keydown.enter.prevent="Topic_STATUS = false"
                    @keydown.space.prevent="Topic_STATUS = false" class="log-toggle-button" variant="text" icon
                    style="cursor: pointer;">
                    <v-icon size="23">mdi-menu-up</v-icon> </v-btn>
                </div>
              </v-col>
            </v-row>
            <div v-if="Topic_STATUS == true" style="padding: 0px;padding-bottom: 9px; ">
              <v-row id="toppic_list_id" style="display: block;">
                <v-col class="col-12 pt-0 pb-2">
                  <div style="padding: 0px;">
                    <v-list density="compact" nav class="pa-2 vlistdiv">
                      <div class="d-flex justify-end">
                        <v-btn variant="text" icon
                          @keydown.enter.prevent="Topic_STATUS = true; Click_History_List(-1, '...', ModelFirst, -1, null);"
                          @keydown.space.prevent="Topic_STATUS = true; Click_History_List(-1, '...', ModelFirst, -1, null);"
                          :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ? NavbarBtnColorTheme : '5179ef')"
                          v-on:click="Topic_STATUS = true; Click_History_List(-1, '...', ModelFirst, -1, null);">
                          <v-img :src="images.chatplusImg" alt="chatplus" width="35" height="35" />
                          <v-tooltip activator="parent" location="top">
                            {{ $t('newChat') }}
                          </v-tooltip>
                        </v-btn>
                      </div>

                      <!-- Edit Mode -->
                      <div v-for="(item, index) in filteredTopics" :key="index" class="mb-2">
                        <div v-if="item.status == true" class="topic-edit-wrapper">
                          <v-text-field class="topic-input-field" :id="'TopicId_' + item.topicID" variant="outlined"
                            color="#3859D0" flat autofocus hide-details density="compact" v-model="item.topicName"
                            @blur="item.status = false; RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token)"
                            @keyup="keyupKeyRename($event)"
                            @keyup.enter.prevent="item.status = false; RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token)">
                            <template v-slot:append-inner>
                              <v-menu location="bottom end" offset="8">
                                <template v-slot:activator="{ props }">
                                  <v-btn variant="text" size="x-small" icon="mdi-dots-vertical" v-bind="props"
                                    class="topic-dots-btn"></v-btn>
                                </template>
                                <v-card class="topic-menu-card" elevation="2">
                                  <v-list density="compact" class="topic-menu-list">
                                    <v-list-item link @click="RenameClick(item, 'TopicId_' + item.topicID)"
                                      class="topic-menu-item topic-menu-item-rename">
                                      <v-list-item-title class="topic-menu-title">{{ $t('rename') }}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item link @click="DeleteTopicStream(item.topicID, item.keyTopic, index)"
                                      class="topic-menu-item">
                                      <v-list-item-title class="topic-menu-title">{{ $t('deleteChat')
                                      }}</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-card>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>

                        <!-- Display Mode -->
                        <div v-else class="topic-display-wrapper"
                          :class="{ 'topic-display-active': Log_History_TopicID == item.topicID }"
                          @click="Click_History_List(item.topicID, item.topicName, item.topicModelID, item.topicModelID_long, item.keyTopic);">
                          <v-text-field class="topic-display-field" variant="outlined" flat readonly hide-details
                            density="compact" :model-value="item.topicName">
                            <template v-slot:append-inner>
                              <v-menu location="bottom end" offset="8">
                                <template v-slot:activator="{ props }">
                                  <v-btn variant="text" size="x-small" icon="mdi-dots-vertical" v-bind="props"
                                    class="topic-dots-btn" @click.stop></v-btn>
                                </template>
                                <v-card class="topic-menu-card" elevation="2">
                                  <v-list density="compact" class="topic-menu-list">
                                    <v-list-item link @click.stop="RenameClick(item, 'TopicId_' + item.topicID)"
                                      class="topic-menu-item topic-menu-item-rename">
                                      <v-list-item-title class="topic-menu-title">{{ $t('rename') }}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item link
                                      @click.stop="DeleteTopicStream(item.topicID, item.keyTopic, index)"
                                      class="topic-menu-item">
                                      <v-list-item-title class="topic-menu-title">{{ $t('deleteChat')
                                      }}</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-card>
                              </v-menu>
                            </template>
                          </v-text-field>
                        </div>
                      </div>
                    </v-list>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
        <v-col cols="12" style="background-color: white; flex: 1; height: calc(-244px + 100vh);
          display: flex; flex-direction: column; margin: 12px; margin-bottom: 25px;
          border-radius: 12px; border: 1px solid #e0e0e0; padding-bottom: 0px; max-width: 80%;"
          :style="SetPopup ? { maxWidth: '80%' } : { maxWidth: '100%' }">
          <v-row justify="space-between" align="center" class="userrow">
            <v-col cols="auto" class="pa-0">
              <div class="user-header-title">
                <span class="user-id-label">{{ User_Id_Show }}</span>
              </div>
            </v-col>
            <v-col cols="auto" class="pa-0">
              <div class="header-actions">
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" icon variant="text" size="small" class="header-icon-btn">
                      <v-img :src="images.chattooltipImg" alt="chattooltip" width="30" height="30" />
                    </v-btn>
                  </template>
                  <div class="tooltip-content">
                    <p class="mb-1">:userid (request MS Team ID)</p>
                    <p class="mb-1">:clearmemory (clear short memory)</p>
                    <p class="mb-1">:memory (show short memory)</p>
                    <p class="mb-0">:model (show all model)</p>
                  </div>
                </v-tooltip>

                <v-btn v-if="roleId == 0 || roleId == 1" id="openfullstream-stream" @click="OpenFullStream()" icon
                  variant="text" size="small" class="header-icon-btn">
                  <v-img :src="images.chatbotImg" alt="chatbot" width="30" height="30" />
                  <v-tooltip activator="parent" location="top">
                    Enter Chat Mode
                  </v-tooltip>
                </v-btn>

                <v-btn @click="SetPopup = !SetPopup" icon variant="text" size="small" class="header-icon-btn">
                  <v-img v-if="SetPopup" :src="images.maxImg" alt="Maximize" width="24" height="24"></v-img>
                  <v-img v-else :src="images.minImg" alt="Minimize" width="24" height="24"></v-img>
                  <v-tooltip activator="parent" location="top">
                    {{ SetPopup ? 'Expand' : 'Minimize' }}
                  </v-tooltip>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <div id="ChatScreId" style=" width: 100%; height: 10px;  overflow-y: auto;  flex-grow: 1;    display: flex; 
                    max-height: 80%;    flex-direction: column; background-color:#ffffff;
                    border-radius: 12px; margin-bottom: 6px;" ref="ChatScreRef" @scroll="ChatScreScroll">
            <div v-if="Loading_History_Status == true">
              <v-progress-linear indeterminate color="#ff4646" class="mb-0"></v-progress-linear>
            </div>
            <div v-for="(item, index) in listMessage" :id="'ChatId_' + item.id" :key="index">
              <v-row style=" margin: 0px;" v-if="item.messageUser != null">
                <v-col col="12" class="d-flex flex-row-reverse">
                  <div class="stream-message-box" :style="chatPanelUserMessageStyle">
                    <p class="stream-request-time" style="right: 12px;white-space: nowrap;">{{ item.requestTime }}</p>
                    <MarkdownRenderer :content="item.messageUser" />
                  </div>
                </v-col>
              </v-row>
              <v-row style=" margin: 0px;"
                v-if="item.status_Process != 'VoiceStart' && item.status_Process != 'ChatChain' && item.messageBot != null">
                <v-col col="12" class="d-flex">

                  <div style="   float: left; height: 35px; width: 35px;  border-radius: 50%;
                          text-align: center;  background-color: white; 
                        margin-top: 10px;    margin-right: 15px;"
                    v-if="item.messageUser != null && item.messageBot != null">
                  </div>
                  <div v-else style="float: left; height: 35px; width: 35px; text-align: center; 
                    margin-top: 10px; margin-right: 15px;"></div>
                  <div v-if="item.status_Process == 'Process'"
                    style="font-size: 16px;    font-weight: 400;    float: left;    width: 175px;">
                    <div style="padding-top: 10px; padding-left: 10px; color: #646464;"> Finding Answer ...</div>
                  </div>
                  <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'"
                    style="float: left; border-radius: 0px 18px 18px 18px;" @click="botMessageClick($event)">
                    <p class="stream-request-time" style="left: 12px;white-space: nowrap;">{{ item.requestTime }}</p>
                    <MarkdownRenderer :content="item.messageBot" />
                  </div>
                  <!-- Error -->
                  <div v-else style="line-break: anywhere;
                    padding: 16px 20px;    background: rgb(249,249,249);
                    border-radius: 8px; box-shadow: 0 2px 4px #00000024, 0 0 2px #0000001f;
                    font-size: 16px;    font-weight: 400;
                    line-height: 22px;    white-space:  pre-line;   
                    width: fit-content;    float: left; max-width: 65%;">
                    <MarkdownRenderer :content="item.messageBot" />
                    <span> ...{{ item.status_Process }}</span>
                  </div>

                </v-col>

              </v-row>

            </div>

            <div ref="ChatRef"></div>

          </div>
          <div class="chat-input-container">
            <!-- Clear Button (Outside) -->
            <v-btn variant="text" icon class="clear-chat-btn" @click="Clear_listMessage" :disabled="listMessage.length === 0 ||
              (listMessage.length > 0 &&
                (listMessage[listMessage.length - 1].status_Process === 'Process' ||
                  listMessage[listMessage.length - 1].status_Process === 'Send_Message' ||
                  listMessage[listMessage.length - 1].status_Process === 'VoiceStart'))">
              <v-img :src="images.cleanImg" width="35" height="35" alt="Clean"></v-img>
              <v-tooltip activator="parent" location="top">{{ $t('clearChat') }}</v-tooltip>
            </v-btn>

            <!-- Main Input Wrapper -->
            <div class="main-input-wrapper">
              <!-- File Previews (Above Input) -->
              <div v-if="fileDataUrl != null || pickedFileType != null" class="file-previews-container">
                <!-- Image Preview -->
                <div v-if="fileDataUrl != null" class="file-preview-container image-preview">
                  <div class="preview-content">
                    <img :src="fileDataUrl" alt="img-upload" class="preview-image">
                    <div class="preview-overlay" v-show="loadingImage">
                      <v-progress-circular indeterminate color="white" size="24" width="3"></v-progress-circular>
                    </div>
                    <v-btn v-show="!loadingImage" icon variant="flat" size="24px" color="error"
                      class="preview-close-btn" @click="ClearImage()">
                      <v-icon size="16">mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>

                <!-- File Attachment Preview -->
                <div v-if="pickedFileType != null" class="file-preview-container file-attachment">
                  <div class="file-content">
                    <div class="file-icon-wrapper">
                      <img :src="pickedFileType" alt="file-type" class="file-icon"
                        :class="{ 'file-processing': !uploadFileComplete }">
                      <v-progress-circular v-if="!uploadFileComplete" indeterminate color="primary" size="20" width="2"
                        class="file-progress-overlay"></v-progress-circular>
                    </div>

                    <div class="file-details">
                      <div class="file-name">{{ pickedFileName }}</div>
                      <div v-if="!uploadFileComplete || (dataAll > 0 && dataUpdate < dataAll)" class="file-progress">
                        <v-progress-linear :model-value="(dataUpdate / dataAll) * 100" color="primary" height="3"
                          rounded></v-progress-linear>
                        <span class="progress-text">{{ Math.round((dataUpdate / dataAll) * 100) }}%</span>
                      </div>
                      <div v-else class="file-status">
                        <v-icon size="12" color="success">mdi-check-circle</v-icon>
                        <span>{{ $t('ready') }}</span>
                      </div>
                    </div>

                    <v-btn icon variant="flat" size="small" color="error" class="file-close-btn"
                      @click="ClearUploadedFile()">
                      <v-icon size="16">mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>

              <!-- Input Row -->
              <div class="input-row">
                <!-- Attachment Button -->
                <v-btn v-if="fileDataUrl == null && pickedFileType == null" icon variant="text"
                  class="input-action-btn">
                  <v-menu activator="parent" transition="slide-y-transition" location="top" offset="8">
                    <v-card class="attachment-menu-card" elevation="3" rounded="xl">
                      <v-list density="comfortable" class="attachment-list">
                        <v-list-item v-for="item in attachItems" :key="item.id" class="attachment-list-item"
                          @click="handleAttachmentItemClick(item.id)" ripple>
                          <template v-slot:prepend>
                            <v-img v-if="item.id === 'files'" :src="images.attachfileImg" width="20" height="20" />
                            <v-img v-else :src="images.attachimageImg" width="20" height="20" />
                          </template>
                          <v-list-item-title class="attachment-title">{{ $t(item.titleKey) }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item class="attachment-list-item" @click="click_music_box()" ripple :disabled="listMessage.length > 0 && listMessage[listMessage.length - 1].status_Process != 'END'
                          && listMessage[listMessage.length - 1].status_Process != 'Stop'
                          && listMessage[listMessage.length - 1].status_Process != 'Error'">
                          <template v-slot:prepend>
                            <v-img :src="images.audiofileImg" width="20" height="20" />
                          </template>
                          <v-list-item-title class="attachment-title">{{ $t('uploadAudioFile') }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                  <v-img :src="images.attachImg" width="35" height="35" alt="Attach"></v-img>
                  <v-tooltip activator="parent" location="top">{{ $t('attachFile') }}</v-tooltip>
                </v-btn>

                <!-- Voice Record Button -->
                <v-btn
                  v-if="listMessage.length > 0 && listMessage[listMessage.length - 1].status_Process === 'VoiceStart'"
                  icon variant="text" class="input-action-btn" @click="TypeInputAudio = 'M'; Click_StopVoice()">
                  <v-icon color="error" size="20">mdi-stop-circle</v-icon>
                  <v-tooltip activator="parent" location="top">{{ $t('stopRecordingLabel') }}</v-tooltip>
                </v-btn>

                <v-btn v-else icon variant="text" class="input-action-btn" @click="click_account_voice" :disabled="listMessage.length > 0 &&
                  listMessage[listMessage.length - 1].status_Process !== 'END' &&
                  listMessage[listMessage.length - 1].status_Process !== 'Stop' &&
                  listMessage[listMessage.length - 1].status_Process !== 'Error'">
                  <v-img :src="images.recordImg" width="35" height="35" alt="Voice Record"></v-img>
                  <v-tooltip activator="parent" location="top">{{ $t('voiceRecord') }}</v-tooltip>
                </v-btn>

                <!-- Model Selection Button -->
                <v-btn icon variant="text" class="input-action-btn" :disabled="listMessage.length > 0 &&
                  listMessage[listMessage.length - 1].status_Process !== 'END' &&
                  listMessage[listMessage.length - 1].status_Process !== 'Stop' &&
                  listMessage[listMessage.length - 1].status_Process !== 'Error'">
                  <v-menu activator="parent" v-model="showModelMenu" transition="slide-y-transition" location="top"
                    offset="8" :close-on-content-click="false" style="min-width: 300px; max-width: 300px;">
                    <v-card class="attachment-menu-card model-menu-card" elevation="3" rounded="xl">
                      <v-card-title class="pa-3 model-menu-title">{{ $t('selectModel') }}</v-card-title>
                      <div class="px-3 pb-2">
                        <v-text-field v-model="modelSearchText" :placeholder="$t('searchByNameOrId')" variant="outlined"
                          density="comfortable" hide-details clearable color="primary" class="model-menu-search">
                          <template #prepend-inner>
                            <v-icon size="16" color="primary">mdi-magnify</v-icon>
                          </template>
                        </v-text-field>
                      </div>
                      <v-divider></v-divider>
                      <div class="model-menu-scroll">
                        <v-list density="comfortable" class="attachment-list model-menu-list pa-0">
                          <v-list-item v-for="(item, index) in filteredModelSelectList"
                            :key="`${item.id ?? 'model'}-${item.modelDisplayID ?? 'unknown'}-${index}`"
                            :class="['attachment-list-item', { 'model-menu-item-active': selectedModelDisplayID === item.modelDisplayID }]"
                            @click="SelectModel(item)" ripple>
                            <template v-slot:prepend>
                              <v-icon size="20" color="primary">mdi-robot-outline</v-icon>
                            </template>
                            <v-list-item-title class="attachment-title text-truncate model-menu-item-title">{{ item.name
                            }}</v-list-item-title>
                            <v-list-item-subtitle class="model-menu-item-subtitle">
                              <span style="font-weight: 500;">ID: {{ item.modelDisplayID }}</span>
                              <span v-if="item.TypeName"> · {{ item.TypeName }}</span>
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item v-if="filteredModelSelectList.length === 0">
                            <v-list-item-title class="model-menu-empty">{{ $t('noModelsFound') }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </div>
                      <v-divider></v-divider>
                      <div class="model-menu-footer d-flex justify-end pa-1">
                        <v-btn variant="text" size="small" color="primary" @click="showModelMenu = false">{{ $t('close')
                        }}</v-btn>
                      </div>
                    </v-card>
                  </v-menu>
                  <v-icon size="24">mdi-robot-outline</v-icon>
                  <v-tooltip activator="parent" location="top">{{ $t('selectModel') }}</v-tooltip>
                </v-btn>

                <!-- Reasoning Effort Selector (pill-style, only when supported) -->
                <div v-if="selectedModelSupportsReasoningEffort" class="reasoning-effort-button-wrapper">
                  <v-menu v-model="showReasoningEffortMenu" transition="slide-y-transition" location="top start"
                    offset="8" :close-on-content-click="false">
                    <template v-slot:activator="{ props: menuProps }">
                      <v-btn v-bind="menuProps" class="reasoning-effort-trigger"
                        :class="{ 'reasoning-effort-trigger--active': showReasoningEffortMenu }" variant="text"
                        :style="getReasoningEffortToneStyle(appliedReasoningEffort)"
                        :title="'Reasoning effort: ' + appliedReasoningEffortLabel">
                        <span class="reasoning-effort-trigger__content">
                          <v-icon size="18" class="reasoning-effort-trigger__icon">mdi-brain</v-icon>
                          <span class="reasoning-effort-trigger__label">{{ appliedReasoningEffortLabel }}</span>
                          <span class="reasoning-effort-trigger__dot"></span>
                        </span>
                      </v-btn>
                    </template>
                    <v-card class="reasoning-effort-menu" elevation="8" rounded="16"
                      :style="getReasoningEffortToneStyle(appliedReasoningEffort)">
                      <div class="reasoning-effort-menu__header">
                        <span class="reasoning-effort-menu__title">{{ $t('reasoningEffort') }}</span>
                        <span class="reasoning-effort-menu__badge">{{ appliedReasoningEffortLabel }}</span>
                      </div>
                      <div class="reasoning-effort-menu__options">
                        <button v-for="option in reasoningEffortOptions" :key="option.value" type="button"
                          class="reasoning-effort-option"
                          :class="{ 'reasoning-effort-option--active': appliedReasoningEffort === option.value }"
                          :style="getReasoningEffortToneStyle(option.value)"
                          @click="SelectReasoningEffort(option.value)">
                          <span class="reasoning-effort-option__icon">
                            <v-icon size="18">{{ option.icon }}</v-icon>
                          </span>
                          <span class="reasoning-effort-option__copy">
                            <span class="reasoning-effort-option__label">{{ option.label }}</span>
                            <span class="reasoning-effort-option__meta">{{ option.meta }}</span>
                          </span>
                          <v-icon v-if="appliedReasoningEffort === option.value" size="16"
                            class="reasoning-effort-option__status">
                            mdi-check-circle
                          </v-icon>
                        </button>
                      </div>
                    </v-card>
                  </v-menu>
                </div>

                <div class="divider"></div>
                <!-- Hidden file input for audio -->
                <input id="inputFileVoid" type="file" @change="Chang_InputFileVoid" style="display: none"
                  aria-label="Upload audio file" accept="audio/wav,audio/mpeg,audio/x-m4a" />

                <!-- Textarea / Waveform Container -->
                <div class="textarea-waveform-container" :color="selectedColor">
                  <!-- Waveform for Recording -->
                  <div v-if="isRecording" class="waveform-recording-container">
                    <div class="recording-info">
                      <div class="recording-indicator">
                        <span class="recording-dot"></span>
                        <span class="recording-text">Recording...</span>
                      </div>
                      <span class="recording-duration">{{ formatRecordingTime(recordingDuration) }}</span>
                    </div>
                    <div id="waveform" ref="waveform" class="waveform"></div>
                  </div>

                  <!-- Normal Textarea -->
                  <v-textarea v-else ref="RefMessageData" v-model="messageData" :maxlength="maximumChatInput"
                    hide-details flat auto-grow @paste="onPaste" @keydown.enter.shift="Key_Ctrl_Flag = true"
                    @keyup.enter.shift="Shift_Enter_MessageData"
                    @keydown.enter.exact.prevent="SendOpenAi('Enter'); Key_Ctrl_Flag = false;" class="message-textarea"
                    rows="1" max-rows="6" variant="solo" clearable counter :placeholder="$t('typeMessageHere')"
                    @click:clear="messageData = ''" :color="selectedColor"
                    style="border-radius: 25px !important;"></v-textarea>
                </div>
                <!-- Voice Record Button -->
                <!-- Send/Stop Button -->
                <!-- ระหว่างอัดเสียง ปุ่มนี้ต้องจบการอัดแบบเดียวกับปุ่มหยุดข้างไมค์ (sessionStopped ส่งข้อความที่พูดต่อเอง) -->
                <v-btn v-if="listMessage.length > 0 && listMessage[listMessage.length - 1].status_Process === 'VoiceStart'"
                  icon variant="flat" class="send-stop-btn" @click="TypeInputAudio = 'M'; Click_StopVoice()">
                  <v-icon color="#C32E0E" size="35">mdi-stop-circle-outline</v-icon>
                  <v-tooltip activator="parent" location="top">{{ $t('stopRecordingLabel') }}</v-tooltip>
                </v-btn>

                <v-btn v-else-if="listMessage.length > 0 &&
                  (listMessage[listMessage.length - 1].status_Process === 'Process' ||
                    listMessage[listMessage.length - 1].status_Process === 'Send_Message')" icon variant="flat"
                  class="send-stop-btn" @click="StopMessage(); clearQueue()">
                  <v-icon color="#C32E0E" size="35">mdi-stop-circle-outline</v-icon>
                  <v-tooltip activator="parent" location="top">{{ $t('stop') }} (clears queue)</v-tooltip>
                </v-btn>

                <v-badge v-else-if="messageQueue.length > 0" :content="messageQueue.length" color="orange" overlap>
                  <v-btn icon variant="text" class="send-stop-btn" @click="SendOpenAi('Click')"
                    :disabled="(uploadFileComplete === false && pickedFileType != null) || messageQueue.length >= maxQueueSize">
                    <v-img v-if="uploadFileComplete === false && pickedFileType != null" :src="images.disablesendImg"
                      width="30" height="30" alt="Send"></v-img>
                    <v-img v-else :src="images.sendImg" width="30" height="30" alt="Send"></v-img>
                    <v-tooltip activator="parent" location="top">{{ $t('send') }} ({{ messageQueue.length }}
                      queued)</v-tooltip>
                  </v-btn>
                </v-badge>

                <v-btn v-else icon variant="text" class="send-stop-btn" @click="SendOpenAi('Click')"
                  :disabled="(uploadFileComplete === false && pickedFileType != null) || messageQueue.length >= maxQueueSize">
                  <v-img v-if="uploadFileComplete === false && pickedFileType != null" :src="images.disablesendImg"
                    width="30" height="30" alt="Send"></v-img>
                  <v-img v-else :src="images.sendImg" width="30" height="30" alt="Send"></v-img>
                  <v-tooltip activator="parent" location="top">{{ $t('send') }}</v-tooltip>
                </v-btn>
              </div>
            </div>

            <!-- Hidden File Upload Components -->
            <DragDropFile ref="imageDragDrop" v-show="false" style="display: none !important;" :dialog="true"
              :DragDrop="false" :ShowListFile="false" :IconBtn="true"
              :allowType="['image/jpeg', 'image/png', 'image/svg+xml']" @filesUploaded="processUploadImage($event)" />

            <DragDropFile ref="fileDragDrop" v-show="false" :dialog="true" :DragDrop="false" :ShowListFile="false"
              :IconBtn="true" :allowType="[
                'text/csv',
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'text/plain',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation'
              ]" @filesUploaded="processUploadFile($event)" />
          </div>
          <!-- Queue Status Indicator -->
          <div v-if="messageQueue.length > 0"
            style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 4px 8px; background: #fff3e0; border-radius: 8px; margin-top: 8px;">
            <span style="font-size: 12px; color: #e65100; font-weight: 500;">{{ messageQueue.length }} message(s)
              queued</span>
            <v-btn variant="text" size="x-small" color="orange" @click="clearQueue">
              <v-icon size="14" start>mdi-close-circle</v-icon>
              {{ $t('clearQueue') || 'Clear Queue' }}
            </v-btn>
          </div>
          <div style="width: 100%; display: flex; justify-content: end; align-items: center;" class="mt-1">
            <span style="font-size: 12px;color: #A6A6A6;margin-bottom: 1px;">{{ messageData.length }} / {{
              maximumChatInput
            }}</span>
          </div>
          <div style="display:flex; justify-content: center;" class="mb-3">
            <span style="font-size: 12px;color: #3859D0;margin-bottom: 1px;">AI can make mistakes. Please double-check
              responses.</span>
          </div>

        </v-col>


      </v-row>
      <div v-if="alertDialog" style="position: fixed; top: 16px; left: 50%; transform: translateX(-50%); z-index: 1000;"
        :class="{ 'fade-in': alertDialog, 'fade-out': !alertDialog }">
        <v-alert color="green" type="success" dismissible @click:close="alertDialog = false">
          The image is downloading...
        </v-alert>
      </div>
      <v-dialog v-model="showImage" max-width="1000">
        <v-card style="
        height: 85vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        box-shadow: none;
        overflow: hidden;
      ">
          <v-img :src="dialogImage" contain style="
          width: 100%;
          height: 100%;
          object-fit: contain;
        " />
        </v-card>
        <div style="position: fixed; bottom: 16px; left: 50%; transform: translateX(-50%);
            display: flex; justify-content: center; gap: 8px; z-index: 1000; opacity: 0; 
            animation: fadeUp 0.3s ease forwards 0.3s;">
          <input type="file" webkitdirectory directory id="folderPicker" aria-label="Select folder"
            style="display: none;">

          <div class="downloadImgBtn" style="background-color:#faa91b;" @click="downloadImage">
            <v-icon color="white">mdi-download</v-icon>
          </div>
          <div class="downloadImgBtn" style="background-color:#FF4444;" fab @click="showImage = false">
            <v-icon color="white">mdi-close</v-icon>
          </div>
        </div>
      </v-dialog>

      <v-dialog ref="form" v-model="Uploaddialog" persistent max-width="600px">
        <v-card style="border-radius: 16px!important;">
          <v-card-title style="box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.03);" class="pa-5">
            <p v-if="TypeInputAudio == 'F'" class="headline">{{ $t('StreamPopupFileHeader') }}
            </p>
            <p v-else class="headline">{{ $t('StreamPopupVoiceHeader') }}</p>
          </v-card-title>
          <v-card-text class="pa-1">
            <v-container>
              <v-form ref="form" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <span>{{ $t('chooseYourLanguage') }}</span>
                    <span style="color: red">*</span>
                    <v-autocomplete :items="DDGPTModel" item-title="name" item-value="value" variant="outlined"
                      v-model="LangPop" class="language modern-input">
                      <template v-slot:prepend-inner>
                        <v-img :src="images.langImg" width="20" height="20" class="mr-2" />
                      </template>
                    </v-autocomplete>
                    <!-- {{ $t('StreamPopuplang')  }} -->
                  </v-col>

                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-3" style="border-top:1px solid var(--Field-border, #C9C9C9)">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="grey" @click="Uploaddialog = false"
              class="dialog-action-btn cancel-btn mr-0">
              <v-icon class="mr-2">mdi-close</v-icon>
              {{ $t("close") }}
            </v-btn>
            <v-btn v-if="TypeInputAudio == 'M'" variant="text" @click="Click_StartVoice(); Uploaddialog = false"
              class="control-btn create-btn customadd">
              <v-img :src="images.recordmicImg" width="24" height="24" alt="record" class="mr-2"></v-img>
              {{ $t('StreamPopupRecord') }}
            </v-btn>
            <v-btn v-else variant="text" class="control-btn create-btn customadd"
              @click="Click_FileButtonVoid(); Uploaddialog = false">
              <v-img :src="images.uploadfileImg" width="20" height="20" alt="record" class="mr-2"></v-img>
              {{ $t('Upload') + " Audio File" }}
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Private Memory -->

      <v-dialog ref="form" v-model="PrivateMemoryDialog_ListFile" persistent max-width="1050px" scrollable>
        <v-card>
          <v-card-title>
            <v-row style=" padding-top: 5px;">
              <v-col cols="12" sm="6" md="6" style="text-align: start; padding-left: 22px;">
                <p class="headline" style="color: #1d4f81;margin-bottom: 0px;">{{ $t('StreamUploadPrivateMemory') }}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6" style="text-align: end;padding-right: 22px;padding-top: 0px;"
                class="btn_PrivateMemoryDialog_ListFile">
                <v-row>
                  <v-col cols="6" sm="6" md="6" style="padding-left:0px;">
                    <v-btn class="primary text-white mt-3" style="margin-left: 0em"
                      @click="OpenPopup_Private_Memory(null)">
                      <v-icon size="20" style="padding-right: 5px;">mdi-upload</v-icon>
                      Upload</v-btn>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" style="padding-left:0px;">
                    <v-btn class="text-white mt-3" style=" background: #faa91b;"
                      @click="PrivateMemoryDialog_ListFile = false;">{{ $t('close') }}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text id="PrivateMemory_ListFile">
            <v-container>
              <v-form ref="form" lazy-validation>
                <v-data-table class="v_data_table_Private_Memory" :items-per-page="itemsPerPage_ListFilePM"
                  :items-length="searchTotalTable_ListFilePM" :options.sync="options_ListFilePM"
                  :items="dataTable_ListFilePM" :headers="headers_ListFilePM" :loading="loadingTable_ListFilePM"
                  loading-text="Loading...">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td style="width: 90px; text-align: center">
                        {{ item.number }}
                      </td>
                      <td>{{ item.fileName }}</td>
                      <td>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on: menu }">
                            <v-btn icon v-on="{ ...menu }">
                              <v-icon size="22">mdi-dots-horizontal</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="Version(item.fileId)">
                              <v-list-item-title>{{ $t('gpt_model_management_version_history') }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                      <td style="text-align: center">
                        <v-btn id="OpenPopup_Private_Memory-stream" icon @click="OpenPopup_Private_Memory(item)">
                          <v-tooltip location="top" :open-delay="500">
                            <template v-slot:activator="{ props }">
                              <img alt="edit" :src="images.edit" v-bind="props" />
                            </template>
                            <span>edit</span>
                          </v-tooltip>
                        </v-btn>
                        <v-btn id="Delete_ListFilePM_ById_Stream-stream" icon
                          @click="Delete_ListFilePM_ById_Stream(item.fileId)">
                          <v-tooltip location="top" :open-delay="500">
                            <template v-slot:activator="{ props }">
                              <img alt="delete" :src="images.delete" v-bind="props" />
                            </template>
                            <span>delete</span>
                          </v-tooltip>
                        </v-btn>
                        <v-switch style="display: inline-block; 
                          padding-left: 0.5em; 
                          padding-top: 0" @change="PrivateVectorOnOffByFileID(item)" v-model="item.isActive"
                          inset></v-switch>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog ref="form" v-model="PrivateMemoryDialog" persistent max-width="1200px" scrollable>
        <v-card>
          <v-card-title>
            <!-- {{ requestVector }} //  -->
            <p class="headline" style="color: #1d4f81">{{ $t('StreamPrivateMemory') }} {{ requestVector.fileId == null
              ||
              requestVector.fileId == -1 ? $t('StreamPrivateMemoryAdd') : $t('StreamPrivateMemoryEdit') }}</p>
          </v-card-title>
          <v-card-text id="PrivateMemory">
            <v-container>
              <v-form ref="form" lazy-validation>
                <v-row>
                  <!--Document Name-->
                  <v-col cols="12" sm="12" md="2">
                    <v-text-field @keypress="handleKeypress" :label="$t('StreamFileNamePrivateMemory')"
                      :rules="[checkValidate()]" :disabled="actionEdit" v-model="requestVector.searchVectorDBName2"
                      variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px;"
                              v-bind="props">mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t('_InfoVectorDatabaseName') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <!--Text Replacement-->
                  <v-col cols="12" sm="12" md="3">
                    <v-autocomplete :label="$t('textReplacement')" :items="DDGroupReplace" item-title="name"
                      item-value="id" multiple chips deletable-chips clearable variant="outlined" density="compact"
                      v-model="tempgroupReplaceID"><template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px"
                              v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoGroupReplaceText') }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <!--Process type-->
                  <v-col cols="12" sm="12" md="2">
                    <v-select :label="$t('process_type')" :items="modeType" item-title="name" item-value="value"
                      variant="outlined" v-model="requestVector.deleteAll" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px"
                              v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoProcess_type') }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                  <!--Custom Max Character-->
                  <v-col cols="12" sm="12" md="2">
                    <v-text-field :rules="[rules.required]" @keypress="numericKey"
                      :label="$t('_InfoCustomMaxCharacter')" v-model="requestVector.MaxLimitedCharacter"
                      variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px"
                              v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoCustomMaxCharacter') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <!--DetectLanguage-->
                  <v-col cols="12" sm="12" md="3">
                    <v-switch v-model="requestVector.DetectLanguage" inset
                      :label="`DetectLanguage : ${requestVector.DetectLanguage ? 'auto' : 'not auto'}`">
                      <template v-slot:label>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <span v-bind="props" aria-hidden="true">{{ `DetectLanguage : ${requestVector.DetectLanguage
                              ? 'auto'
                              : 'not auto'}` }}</span>
                          </template>
                          <span>{{ $t('_InfoDetectLanguage') }}</span>
                        </v-tooltip>
                      </template>
                    </v-switch>
                  </v-col>
                </v-row>
                <v-row style="margin-top: -1rem;">
                  <!--Doctype-->
                  <v-col cols="12" sm="12" md="2">
                    <v-select :rules="[rules.required]" :label="$t('doctype')" :items="datadoctype" item-title="name"
                      item-value="value" v-model="doctype" variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px"
                              v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoDoctype') }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                  <!--Vectortype-->
                  <v-col cols="12" sm="12" md="2">
                    <v-select :rules="[rules.required]" :label="$t('vectortype')" :items="filterdatavectortype"
                      item-title="name" item-value="value" v-model="vectortype" variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px"
                              v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoVectortype') }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                  <!--Type-->
                  <v-col cols="12" sm="12" md="3">
                    <v-autocomplete :rules="[rules.required]" :label="$t('type')" :items="filterDDType"
                      item-title="name" item-value="value" v-model="requestVector.modelType" clearable
                      variant="outlined" density="compact">
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                          </v-list-item-content>
                          <v-tooltip location="right">
                            <template v-slot:activator="{ props }">
                              <v-list-item-icon v-bind="props">
                                <v-icon> mdi-information</v-icon>
                              </v-list-item-icon>
                            </template>
                            <span>
                              <img :src="data.item.image" alt="Tooltip preview" width="300">
                            </span>
                          </v-tooltip>
                        </template>
                      </template>
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px"
                              v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfofillterModelType') }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="2" v-show="requestVector.modelType == 3">
                    <v-text-field :rules="[checkCustomCharacterValidate()]" :label="$t('customCharacter')"
                      v-model="requestVector.customCharacter" variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px"
                              v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_addReplaceExplain') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-row justify="end">
                    <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: end;">
                      <v-btn class="primary text-white mt-3" style="margin-left: 1rem;"
                        @click="TemplateVectorDialog()">{{
                          $t('template') }}</v-btn>
                      <DragDropFile :dialog="true" :DragDrop="false" :ShowListFile="false" :accept="accept"
                        :allowType="[]" @filesUploaded="processUpload($event)" />
                    </v-col>
                  </v-row>
                </v-row>
                <v-row style="margin-top: -1rem;">
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field :label="$t('textOrgCol')" v-model="searchtext_org"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="1">
                    <v-btn fab class="primary text-white mt-3" @click="Search()">
                      <v-icon size="30">mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row justify="end">
                    <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: end;">
                      <v-btn class="text-white mt-3"
                        style="margin-left: 1rem; border-radius: 25.342px; background: #9747ff; width: 100px"
                        @click="ReProcess()">{{ $t('reprocess') }}</v-btn>
                      <v-btn class="text-white mt-3"
                        style="margin-left: 1rem; border-radius: 25.342px; background: #139fd7" @click="ReFresh()">{{
                          dataUpdate }} of {{ dataAll }}
                        <v-icon>mdi-refresh</v-icon></v-btn>
                      <v-btn class="primary text-white mt-3" style="margin-left: 1rem" @click="AddVectorperChunk()">
                        <v-icon size="20" style="padding-right: 5px">mdi-plus-circle-outline</v-icon>
                        {{ $t('add') }}</v-btn>
                    </v-col>
                  </v-row>
                </v-row>



                <v-row>
                  <v-col cols="12" style="display: inline-flex; justify-content: right;">
                    <v-checkbox v-model="checkBoxShowAllText"
                      :label="`${$t('_ShowAllText')}: ${checkBoxShowAllText ? $t('_ShowAllTextOn') : $t('_ShowAllTextOff')}`"></v-checkbox>
                  </v-col>
                </v-row>
                <v-col cols="12" sm="12" md="2" style="display: inline-flex; justify-content: end"> </v-col>

                <!-- {{ showTable }} -->
                <v-data-table v-show="showTable == true" :items-per-page="itemsPerPage" :items-length="searchTotalTable"
                  v-model:options="options" :items="dataTable" :headers="headers" :loading="loadingTable"
                  loading-text="Loading..." fixed-header mobile-breakpoint="300" class="elevation-1 responsive-table">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td style="text-align:center">
                        {{ item.number }}
                      </td>
                      <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']"
                            v-html="formatText(item.textORG)"> </span>
                        </div>
                      </td>
                      <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']"
                            v-html="formatText(item.textEN)"> </span>
                          <v-btn icon rounded @click="item.show = !item.show">
                            <v-icon style="color:black;">{{ item.show ? 'mdi-chevron-up' : 'mdi-chevron-down'
                            }}</v-icon>
                          </v-btn>
                        </div>
                      </td>
                      <td style="text-align: center">
                        <v-btn icon @click="EditVectorperChunk(item)" v-if="!item.flagGenerateVector">
                          <v-tooltip location="top" :open-delay="500">
                            <template v-slot:activator="{ props }">
                              <img alt="edit" :src="images.edit" v-bind="props" />
                            </template>
                            <span>edit</span>
                          </v-tooltip>
                        </v-btn>
                        <v-btn icon @click="DeleteById(item.id)">
                          <v-tooltip location="top" :open-delay="500">
                            <template v-slot:activator="{ props }">
                              <img alt="delete" :src="images.delete" v-bind="props" />
                            </template>
                            <span>delete</span>
                          </v-tooltip>
                        </v-btn>
                        <v-switch style="display: inline-block; 
                          padding-left: 0.5em; 
                          padding-top: 0" @change="VectorOnOff(item)" v-model="item.activeFlag" inset></v-switch>
                      </td>
                    </tr>
                  </template>
                </v-data-table>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-banner>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="error" style="margin-right: 3em; margin-top: 1em"
                          @click="DeleteByName(KeyTopic)" v-if="showTable == true" :disabled="searchTotalTable == 0">{{
                            $t('deleteAll')
                          }}</v-btn>


                        <v-btn class="text-white mt-3" v-if="showTable == true"
                          style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 120px"
                          @click="SaveFileName_PrivateMemoryStream">{{ $t('close') }}</v-btn>
                      </v-card-actions>
                    </v-banner>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog ref="form" v-model="EditVector" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">{{ $t('editVector') }}</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea :label="$t('textOrgCol')" variant="outlined" counter auto-grow rows="15"
                      v-model="Edit.textORG" required></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="closeUploaddialog">{{ $t('close') }}</v-btn>
            <v-btn color="blue-darken-1" variant="text" @click="SaveEdit()">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog ref="form" v-model="AddVector" max-width="800px">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">{{ $t('addVector') }}</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea :label="$t('textOrgCol')" variant="outlined" counter auto-grow rows="15"
                      v-model="Add.textORG" required></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="closeUploaddialogAdd">{{ $t('close') }}</v-btn>
            <v-btn color="blue-darken-1" variant="text" @click="SaveAdd()">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-dialog v-model="TemplateVector" max-width="800px">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">{{ $t('templateVector') }}</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-data-table class="v_data_table_Private_Memory" :items="dataTemplate" :headers="headersTemplate"
                loading-text="Loading..." hide-default-footer disable-sort>
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="width: 81px; text-align: center">
                      {{ item.modeType }}
                      <template v-if="item.modeType == 'CustomSplit'">
                        <v-tooltip location="bottom">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-information</v-icon>
                          </template>
                          <span>Template CustomSplit use "||!" Example SplitChunkContent</span>
                        </v-tooltip>
                      </template>
                    </td>
                    <td style="text-align: center" v-if="item.modeType != 'CustomSplit' && item.modeType != 'Article'">
                      <v-btn icon @click="linkDownload(item.modeType, item.CSV)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file</v-icon>
                          </template>
                          <span>{{ item.modeType }} - CSV</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center" v-if="item.modeType != 'CustomSplit' && item.modeType != 'Article'">
                      <v-btn icon @click="linkDownload(item.modeType, item.Excel)"
                        v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-excel</v-icon>
                          </template>
                          <span>{{ item.modeType }} - Excel</span>
                        </v-tooltip>
                      </v-btn>
                      <v-btn icon @click="linkDownload(item.modeType, item.ExcelMultiColumn)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-excel-box</v-icon>
                          </template>
                          <span>{{ item.modeType }} - Excel (Multiple column)</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center"
                      v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn icon @click="linkDownload(item.modeType, item.PDF)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-pdf-box</v-icon>
                          </template>
                          <span>{{ item.modeType }} - PDF</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center"
                      v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn icon @click="linkDownload(item.modeType, item.Word)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-word</v-icon>
                          </template>
                          <span>{{ item.modeType }} - Word</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center"
                      v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn icon @click="linkDownload(item.modeType, item.PowerPoint)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-powerpoint</v-icon>
                          </template>
                          <span>{{ item.modeType }} - PowerPoint</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center"
                      v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn icon @click="linkDownload(item.modeType, item.Text)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-file-document</v-icon>
                          </template>
                          <span>{{ item.modeType }} - Text</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="TemplateVector = false">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_version" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">{{ $t('gpt_model_management_version_history') }}</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-data-table :items-per-page="itemsPerPage_version" :items-length="searchTotalTable_version"
                :options.sync="options_version" :items="menus_version" :headers="headers_version_history"
                :footer-props="{ 'items-per-page-options': [5] }">
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="text-align: center">{{ item.version }}</td>
                    <td style="text-align: center">{{ item.createDate }}</td>
                    <td style="text-align: center">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on: menu }">
                          <v-btn icon v-on="{ ...menu }">
                            <v-icon size="22">mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item :key="item.id" @click="changeRestoreNewVersion(item.id, item.fileId)">
                            <v-list-item-title>{{ $t('restore') }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="viewVersion(item.id, item.fileId, item.keytopic)">
                            <v-list-item-title>{{ $t('view') }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                    <td style="text-align: center">{{ item.createBy }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="dialog_version = false">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--dialog view private vector version-->
      <v-dialog v-model="dialog_view_private" width="80vw">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">{{ $t('gpt_model_management_version_history_detail') }}</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-data-table :items-per-page="itemsPerPage" :items-length="searchTotalTable_view_private"
                :options.sync="options_view_private" :items="view_private_version"
                :headers="header_view_private_version" class="elevation-1 responsive-table">
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="dialog_view_private = false">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="loading" persistent width="300">
        <v-card color="#1976D2">
          <v-card-text class="text-white">
            Loading Please Wait...
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { toRaw } from 'vue';
import MarkdownRenderer from '@/components/MarkedMarkdown.vue'
// import MarkdownIt from '@/components/MarkedMarkdown.vue'
import DragDropFile from '@/components/DragDropFile.vue';
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import group11Img from "@/assets/images/Group 11.svg";
import group12Img from "@/assets/images/Group 12.svg";
import group13Img from "@/assets/images/Group 13.svg";

import chatImagePreviewMixin from '@/mixins/chatImagePreviewMixin.js';
import vectorTypeWatchersMixin from '@/mixins/vectorTypeWatchersMixin.js';
import chatVoiceInputMixin from '@/mixins/chatVoiceInputMixin.js';
import * as streamMarkdownMarkers from '@/utils/streamMarkdownMarkers';
import { isInputTooLongError, parseServerCharLimit } from '@/utils/chatInputLimit';
import { replaceLeadingNewlines, buildShortMemoryText } from '@/utils/chatLogText';

import chatbotImg from '@/assets/images/Aichatbot.svg';
import chattooltipImg from '@/assets/images/Info_Chatplayground.svg';
import maxImg from '@/assets/Icons/maximize.png';
import minImg from '@/assets/Icons/mini.svg';
import parameterImg from '@/assets/images/parameter.png';
import logImg from '@/assets/images/logs.png';
import chatImg from '@/assets/images/wechatline.png';

import cleanImg from '@/assets/Icons/cleanicon.png';
import attachImg from '@/assets/Icons/Attachment.png';
import recordImg from '@/assets/Icons/voicerecord.png';
import sendImg from '@/assets/Icons/sendicon.png';
import disablesendImg from '@/assets/Icons/disablesendicon.png';
import recordmicImg from '@/assets/Icons/recordmic.png';
import attachfileImg from '@/assets/images/attachment-line.svg';
import audiofileImg from '@/assets/images/audio-book.svg';
import langImg from '@/assets/images/language-line.svg';
import uploadfileImg from '@/assets/images/uploadwhite.png';
import chatplusImg from '@/assets/images/chatplus.svg';
import attachimageImg from '@/assets/images/attachimage.svg';

const API_BASE_URL = import.meta.env?.VITE_APP_API
export default {
  name: "Stream",
  mixins: [chatImagePreviewMixin, vectorTypeWatchersMixin, chatVoiceInputMixin],
  inject: ['flagNav', 'Status_Error', 'User_Id_Show', 'User_Id', 'Time_Delay', 'Flag_Click_History'
    , 'SetPopup', 'NavbarBtnColorTheme', 'ModelFirst', 'TopicName', 'listTopic'
    , 'Click_History_List', 'DeleteTopicStream', 'RenameClick', 'Log_History_TopicID'
    , 'RenameTopicStream', 'keyupKeyRename', 'auth_token', 'KeyTopic'
    , 'TopicModelID', 'TopicModelID_long', 'StatusKeyRename', 'GetModelFirst_Value'
    , 'IsAllowImage', 'FileUploadLimit', 'IsChainMassage'
    , 'Log_History_ID', 'Log_History_Take', 'GetModelFirst', 'FontColorTitle', 'SubNavbarBackGround'
    , 'IconChat', 'ChatbotName', 'colorThemeChat', 'isImgIconChat', 'ChatbotIcon', 'ChatPanelFontColorTheme'],
  components: {
    // VueMarkdown, 
    DragDropFile,
    MarkdownRenderer
  },
  data: () => ({
    chatSearchQuery: '',
    maximumChatInput: 200000,
    showImage: false,
    dialogImage: '',
    GetLogStreamStart_Flag: true,
    streamAuthToken: '',

    DataLog_Data: "",

    roleId: Cookies.get('roleId'),
    messageImage: "",
    Flag_Start: false,

    LastScrollTop: null,
    Loading_History_Status: false,


    Topic_STATUS: false,

    LOG_STATUS: false,
    AI_ATTEMPTS_STATUS: false,
    // url: enurl.apiUrl, 

    TimeOutStop: null,

    // 5 s
    TimeoutFirst: 5000,
    //Timeout: 60000,
    // 10 s
    // Timeout: 10000,

    // 7 s
    Timeout: 7000,

    // Timeout: 10000,
    SpeechRecognizer: null,

    TypeInputAudio: "",
    Uploaddialog: false,


    LangPop: "th-TH",
    DDGPTModel: [{ name: "TH", value: "th-TH" }, { name: "EN", value: "en-US" }],

    DDModelSelectList: [],
    showModelMenu: false,
    modelSearchText: '',
    // NEW: persist model selector state inside the existing dropdown
    selectedModelDisplayID: null,
    appliedReasoningEffort: 'low',
    showReasoningEffortMenu: false,
    reasoningEffortOptions: [
      {
        value: 'low',
        label: 'Low',
        meta: 'Quick replies',
        icon: 'mdi-lightning-bolt-outline',
        color: '#16a34a',
      },
      {
        value: 'medium',
        label: 'Medium',
        meta: 'Balanced depth',
        icon: 'mdi-tune-variant',
        color: '#2563eb',
      },
      {
        value: 'high',
        label: 'High',
        meta: 'Deeper thinking',
        icon: 'mdi-head-cog-outline',
        color: '#FF4500',
      },
    ],

    anchorAttrs: {
      target: '_blank',
      rel: 'noopener noreferrer nofollow'
    },

    DataLog: {
      Prompt: "",
      Vector: "",
      ReplySQL: "",
      ReplyDataSelect: "",
      Memory: "",
      Translate: "",
      FlowActionIntent: "",
      GPT_Model: {
        ModelID: "",
        ModelName: "",
        Provider: "",
        Model: "",
        Extension: "",
        Description: "",
        promptTemplate: "",
        gender: "",
        vectordbName: "",
        TopVDB: "",
        internet: "",
        feedback: "",
        HistoryCount: "",
        HistoryMinute: "",
        temperature: "",
        top_p: "",
        frequency_penalty: "",
        presence_penalty: "",
        Stop: "",
        max_tokens: "",
        IsStream: "",
        EndpointURL: "",
      },
      Text: "",
      TextVector: "",
      VectorCoise: "",
      Private_Memory: "",
      AiAttempts: []
    },

    point: 0,
    Key_Ctrl_Flag: false,
    Stop_Flag: false,
    StopForChain: false,
    Axios_Controller: [],
    Axios_ControllerAduio: null,

    listMessage: [],
    messageData: "",

    CountScroll: 0,
    MaxCountScroll: 15,
    messageRes: [],
    Count_messageRes: [],
    StatusPro: false,
    // messageRun: "",

    // Input Chaining Queue
    messageQueue: [],
    isProcessing: false,
    maxQueueSize: 10,

    auth_token: "",
    // ModelFirst: "-",

    PrivateMemoryDialog_ListFile: false,
    PrivateMemoryDialog: false,
    PrivateMemory_Disabled_Name: true,

    Axios_VECTOR: null,
    sortBy: [],
    sortDesc: [],

    isSearch: false,
    images: {
      edit: editImg,
      delete: deleteImg,
      chatbotImg: chatbotImg,
      chattooltipImg: chattooltipImg,
      maxImg: maxImg,
      minImg: minImg,
      parameterImg: parameterImg,
      logImg: logImg,
      chatImg: chatImg,
      cleanImg: cleanImg,
      attachImg: attachImg,
      recordImg: recordImg,
      sendImg: sendImg,
      disablesendImg: disablesendImg,
      recordmicImg: recordmicImg,
      attachfileImg: attachfileImg,
      audiofileImg: audiofileImg,
      langImg: langImg,
      uploadfileImg: uploadfileImg,
      chatplusImg: chatplusImg,
      attachimageImg: attachimageImg,
    },

    AddVector: false,
    flagNew: false,
    Add: {
      id: null,
      textORG: null,
    },
    totalTable: 0,

    loadingTable: false,
    showTable: true,

    options: { "page": 1, "itemsPerPage": 10, "sortBy": [], "sortDesc": [false], "groupBy": [], "groupDesc": [], "mustSort": false, "multiSort": false },
    dataTable: [],
    searchTotalTable: 0,
    itemsPerPage: 10,

    // VectorDBName: "",
    dataUpdate: 0,
    dataAll: 0,
    exceptionFlag: false,
    imageData: null,
    TemplateVector: false,
    tempgroupReplaceID: null,
    pickedFileType: null,
    pickedFileName: null,
    DDGroupReplace: [],
    DDType: [
      {
        name: 'General',
        value: 1,
        image: group11Img
      },
      {
        name: 'MaxCharacter',
        value: 2,
        image: group12Img
      },
      {
        name: 'CustomSplit',
        value: 3,
        image: group13Img
      },
      {
        name: 'Article',
        value: 4,
        image: group13Img
      },
      {
        name: 'HeaderAllChunk',
        value: 5,
        image: group11Img
      },
      {
        name: 'HeaderFirstChunk',
        value: 6,
        image: group12Img
      },
      {
        name: 'WordImage',
        value: 7,
        image: group12Img
      },
      {
        name: 'PDFImage',
        value: 8,
        image: group12Img
      },
    ],
    datadoctype: [
      { name: 'CSV', value: 1 },
      { name: 'Excel', value: 2 },
      { name: 'PDF', value: 3 },
      { name: 'Word', value: 4 },
      { name: 'Text', value: 5 },
      { name: 'PowerPoint', value: 6 },
    ],
    datavectortype: [
      { name: 'General', value: 1 },
      { name: 'Article', value: 2 },
      { name: 'PriceList', value: 3 },
    ],
    dataTemplate: [
      {
        modeType: 'General',
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: 'MaxCharacter',
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: 'CustomSplit',
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: 'Article',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'HeaderAllChunk',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'HeaderFirstChunk',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
    ],
    rules: {
      required: (value) => !!value || 'Required.',
      // required2 : this.vectornameDuplicate || 'dup' 
    },
    VectorDBNameDuplicate: '',
    doctype: null,
    vectortype: null,
    filterdatavectortype: [],
    filterDDType: [],
    accept: '',
    searchtext_org: null,
    actionEdit: false,
    modelType: null,
    MaxLimitedCharacter: null,
    showAllText: false,
    checkBoxShowAllText: false,
    uploadFileComplete: false,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: false,
      groupReplaceID: null,
      customCharacter: null,
      DetectLanguage: true,
      USER_CHANNEL: null,
      TopicID: null,
      topVDB: 3,
      // cosine: null,
      cosine: -1,
      //fileName: "",
      searchVectorDBName2: "",
      fileId: -1,
      MaxLimitedCharacter: null,
    },
    requestUpload: {
      entity: null,
      USER_CHANNEL: null
    },
    modeType: [
      {
        name: 'Add',
        value: false,
      },
      {
        name: 'Replace',
        value: true,
      },
    ],
    EditVector: false,
    Edit: {
      id: null,
      textORG: null,
    },

    totalTable_ListFilePM: 0,
    isSearch_ListFilePM: false,
    loadingTable_ListFilePM: false,
    sortBy_ListFilePM: [],
    sortDesc_ListFilePM: [],
    options_ListFilePM: {},
    dataTable_ListFilePM: [],
    searchTotalTable_ListFilePM: 0,
    itemsPerPage_ListFilePM: 10,
    showHelp: false,
    today: null,
    allAttachItems: [
      { id: 'images', titleKey: 'attachImages', icon: 'mdi-image' },
      { id: 'files', titleKey: 'attachFiles', icon: 'mdi-paperclip' }
    ],
    dialog_version: false,
    options_version: {},
    itemsPerPage_version: 5,
    menus_version: [],
    searchTotalTable_version: 0,
    totalTable_version: 0,
    fileID: null,
    loading: false,
    ImageURL: null,
    fileDataUrl: null,
    loadingImage: false,
    SessionID: null,
    //dialog view private
    dialog_view_private: false,
    searchTotalTable_view_private: 0,
    totalTable_view_private: 0,
    options_view_private: { "sortBy": [null], "sortDesc": [null] },
    view_private_version: [],
    privateID: null,
    temKeytopic: null,
    flagTopHistory: false,
    alertDialog: false,
    selectedColor: '#FFA41E',

    // wave data
    wavesurfer: null,
    recordPlugin: null,
    isRecording: false,
    recordedBlob: null,
    recordingDuration: 0,
    recordingTimer: null,
  }),

  watch: {
    showModelMenu(val) {
      if (!val) {
        this.modelSearchText = '';
      }
    },
    selectedModelSupportsReasoningEffort(val) {
      if (!val) {
        this.showReasoningEffortMenu = false;
      }
    },

    User_Id_Show: function () {
      if (this.Flag_Start) {

        this.User_Id_Show = (this.User_Id_Show == null ? '' : this.User_Id_Show);
        this.User_Id = (this.User_Id == null ? '' : this.User_Id);
        if (this.User_Id_Show != null && this.User_Id_Show != "" && this.User_Id_Show.replaceAll(' ', '') != "") {

          this.User_Id = this.User_Id_Show;

        }
        else if (this.User_Id_Show.replaceAll(' ', '') == "" && this.User_Id.split('-').length == 6) {
          console.log("User_Id_Show : " + this.User_Id_Show + " ,User_Id-length : " + this.User_Id.split('-').length);
        }
        else {
          this.User_Id = this.GetUuidv4_Fun_User_Id_Null();
        }
      }
      else {
        // no action required
      }
    },

    User_Id: function () {
      // console.log(newValue)
      // alert("DD")

      if (this.Flag_Start) {
        this.Log_History_TopicID = -1;
        this.TopicName = "";
        this.TopicModelID = "";
        this.KeyTopic = "";

        this.TopicModelID_long = -1;
        this.Chang_History();


        this.GetLogStreamStart_Flag = true;
        this.GetTopicStream("Start");

        this.GetModelFirst_Value(null);
      }
      else {
        this.Flag_Start = true;
      }
    },
    /*
    "$parent.$parent.$parent.Flag_Click_Rename": function () {
      var that = this;

      that.GetTopicStream("ChangHistory");


    },
*/
    Flag_Click_History: function () {
      this.Chang_History();
      if (this.Log_History_TopicID != -1) {
        this.GetTopicStream("ChangHistory");
      }
    },
    options_ListFilePM: {
      handler() {
        this.GetListFile_PrivateMemoryStream("");
      },
      deep: true,
    },
    options: {
      handler() {
        this.GetByVector();
      },
      deep: true,
    },
    options_version: {
      handler() {
        this.Version(this.fileID);
      },
      deep: true,
    },
    options_view_private: {
      handler() {
        this.viewVersion(this.privateID, this.fileID, this.temKeytopic);
      },
      deep: true,
    },
    checkBoxShowAllText(newVal) {
      if (newVal) {
        this.ShowAll();
      } else {
        this.CloseShowAll();
      }
    },
    colorThemeChat: {
      handler(newVal) {
        this.selectedColor = `#${newVal}`;
      },
      immediate: true
    },
  },

  computed: {
    attachItems() {
      if (!this.IsAllowImage) {
        return this.allAttachItems.filter(item => item.id === 'files');
      }
      return this.allAttachItems;
    },
    filteredModelSelectList() {
      if (!this.modelSearchText || this.modelSearchText.trim() === '') {
        return this.DDModelSelectList;
      }
      const q = this.modelSearchText.toLowerCase();
      return this.DDModelSelectList.filter(item =>
        (item.name && item.name.toLowerCase().includes(q)) ||
        (item.modelDisplayID != null && String(item.modelDisplayID).includes(q))
      );
    },
    selectedModelSupportsReasoningEffort() {
      if (this.selectedModelDisplayID == null) {
        return false;
      }
      const selected = this.DDModelSelectList.find(item => item.modelDisplayID === this.selectedModelDisplayID);
      return selected?.useReasoningEffort === true;
    },
    appliedReasoningEffortLabel() {
      return this.FormatReasoningEffortLabel(this.appliedReasoningEffort);
    },
    filteredTopics() {
      if (!this.chatSearchQuery) {
        return this.listTopic;
      }
      const query = this.chatSearchQuery.toLowerCase();
      return this.listTopic.filter(topic =>
        topic.topicName.toLowerCase().includes(query)
      );
    },
    headers_ListFilePM() {
      return [
        { text: this.$t('no'), align: 'center', sortable: false, },
        { text: this.$t('StreamFileNamePrivateMemory'), value: 'fileName', align: 'center', sortable: true },
        { text: ' ', value: ' ', align: 'center', sortable: false },
        { text: this.$t('manage'), align: 'center', sortable: false },
      ];
    },

    headers() {
      return [
        {
          text: this.$t('no'),
          align: 'center',
          sortable: false,
          width: this.$vuetify.breakpoint.smAndUp ? '60px' : '30px',
        },
        { text: this.$t('textOrgCol'), value: 'TextORG', align: 'center', width: this.$vuetify.breakpoint.smAndUp ? '40%' : '300px' },
        { text: this.$t('textEnCol'), value: 'TextEN', align: 'center', width: this.$vuetify.breakpoint.smAndUp ? '40%' : '300px' },
        { text: this.$t('manage'), align: 'center', sortable: false, width: this.$vuetify.breakpoint.smAndUp ? '15%' : 'auto' },
      ];
    },

    headersTemplate() {
      return [
        { text: this.$t('type'), align: 'center', width: '25%' },
        { text: 'CSV', align: 'center' },
        { text: 'Excel', align: 'center' },
        { text: 'PDF', align: 'center' },
        { text: 'Word', align: 'center', },
        { text: 'PowerPoint', align: 'center' },
        { text: 'Text', align: 'center' },
      ];
    },

    headers_version_history() {
      return [
        { text: this.$t('version'), align: 'center', sortable: false, width: '95px' },
        { text: this.$t('modified'), align: 'center', sortable: false },
        { text: ' ', align: 'center', sortable: false },
        { text: this.$t('modifiedBy'), align: 'center', sortable: false },
      ];
    },

    header_view_private_version() {
      return [
        { text: this.$t('no'), value: 'number', align: 'center', justify: 'center', sortable: false, width: '100px' },
        { text: this.$t('textOrgCol'), value: 'textORG', align: 'center', sortable: true, },
        { text: this.$t('textEnCol'), value: 'textEN', align: 'center', sortable: true, },
      ];
    },
    ColorThemeChat() {
      return this.colorThemeChat;
    },
    chatPanelHeaderBackgroundColor() {
      return this.selectedColor;
    },
    chatPanelUserMessageStyle() {
      return {
        float: 'right',
        backgroundColor: this.chatPanelHeaderBackgroundColor,
        color: this.ChatPanelFontColorTheme ? `#${this.ChatPanelFontColorTheme}` : '#171717',
      };
    },
  },

  methods: {
    GetDDGPTModelList() {
      this.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDModelSelectList = dataResponse.data;
          } else {
            this.DDModelSelectList = [];
          }
        },
        (errorResource) => {
          this.DDModelSelectList = [];
          console.error(errorResource);
        }
      );
    },
    // UPDATED: keep model selection state so reasoning_effort can be changed later without reselecting the model
    async SelectModel(model) {
      if (this.listMessage.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process !== 'END' &&
        this.listMessage[this.listMessage.length - 1].status_Process !== 'Stop' &&
        this.listMessage[this.listMessage.length - 1].status_Process !== 'Error') {
        return;
      }

      this.selectedModelDisplayID = model.modelDisplayID;
      this.showModelMenu = false;
      const tokenReady = await this.EnsureStreamToken();
      if (!tokenReady) {
        alert(this.$t('cannotSelectModel'));
        return;
      }
      this.messageData = ':model ' + model.modelDisplayID;
      this.$nextTick(() => {
        this.SendOpenAi('Click');
      });
    },
    SelectReasoningEffort(reasoningEffort) {
      if (!this.selectedModelSupportsReasoningEffort) {
        this.showReasoningEffortMenu = false;
        return;
      }

      this.appliedReasoningEffort = this.NormalizeReasoningEffort(reasoningEffort);
      this.showReasoningEffortMenu = false;
    },
    GetAppliedReasoningEffort(reasoningEffort = this.appliedReasoningEffort) {
      return this.selectedModelSupportsReasoningEffort
        ? this.NormalizeReasoningEffort(reasoningEffort)
        : null;
    },
    NormalizeReasoningEffort(reasoningEffort) {
      const normalizedReasoningEffort = reasoningEffort?.toString().trim().toLowerCase();
      return ['low', 'medium', 'high'].includes(normalizedReasoningEffort) ? normalizedReasoningEffort : 'low';
    },
    FormatReasoningEffortLabel(reasoningEffort) {
      const normalized = this.NormalizeReasoningEffort(reasoningEffort);
      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
    },
    GetReasoningEffortOption(reasoningEffort) {
      const normalized = this.NormalizeReasoningEffort(reasoningEffort);
      return this.reasoningEffortOptions.find((option) => option.value === normalized) || this.reasoningEffortOptions[0];
    },
    getReasoningEffortToneStyle(reasoningEffort) {
      const option = this.GetReasoningEffortOption(reasoningEffort);
      return {
        '--reasoning-tone-color': option?.color || '#64748b',
      };
    },
    Themecolor() {
      this.selectedColor = this.colorThemeChat == null ? '#FFA41E' : `#${this.colorThemeChat}`;
    },
    getCurrentStreamToken() {
      const token = this.streamAuthToken || (typeof this.auth_token === 'string' ? this.auth_token : this.auth_token?.value) || '';
      return token && token !== 'undefined' && token !== 'null' ? token : '';
    },
    async EnsureStreamToken() {
      if (this.getCurrentStreamToken()) {
        return true;
      }
      return await this.GetToken();
    },
    BuildStreamSource() {
      return {
        type: 'user',
        userId: this.User_Id,
        modelDisplayID: this.selectedModelDisplayID == null ? null : String(this.selectedModelDisplayID),
      };
    },
    getWaveSurferRecordPlugin() {
      return globalThis.RecordPlugin || globalThis.WaveSurfer?.Record || globalThis.WaveSurfer?.RecordPlugin || null;
    },
    finalizeWaveSurferRecordPlugin(resolve, reject) {
      if (!globalThis.WaveSurfer) {
        reject(new Error('WaveSurfer not found after loading'));
        return;
      }

      const RecordPlugin = this.getWaveSurferRecordPlugin();
      if (!RecordPlugin) {
        reject(new Error('RecordPlugin not found after loading'));
        return;
      }
      resolve(RecordPlugin);
    },
    loadWaveSurferRecordPlugin(resolve, reject) {
      // Load Record plugin
      const script2 = document.createElement('script');
      script2.src = 'https://cdn.jsdelivr.net/npm/wavesurfer.js@7.7.15/dist/plugins/record.min.js';

      script2.onload = () => {

        // Small delay to ensure plugin is registered
        setTimeout(() => {
          this.finalizeWaveSurferRecordPlugin(resolve, reject);
        }, 100);
      };

      script2.onerror = () => reject(new Error('Failed to load Record plugin script'));
      document.head.appendChild(script2);
    },
    loadWaveSurferCDN() {
      return new Promise((resolve, reject) => {
        // Check if already loaded
        if (globalThis.WaveSurfer && this.getWaveSurferRecordPlugin()) {
          resolve(this.getWaveSurferRecordPlugin());
          return;
        }

        // Load main WaveSurfer library
        const script1 = document.createElement('script');
        script1.src = 'https://cdn.jsdelivr.net/npm/wavesurfer.js@7.7.15/dist/wavesurfer.min.js';

        script1.onload = () => {

          // Small delay to ensure WaveSurfer is ready
          setTimeout(() => {
            this.loadWaveSurferRecordPlugin(resolve, reject);
          }, 100);
        };

        script1.onerror = () => reject(new Error('Failed to load WaveSurfer script'));
        document.head.appendChild(script1);
      });
    },
    formatRecordingTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },
    async startRecording() {
      try {

        // Step 1: Load WaveSurfer
        await this.loadWaveSurferCDN();

        // Step 2: Set recording state
        this.isRecording = true;
        this.recordingDuration = 0;

        // Wait for DOM update
        await this.$nextTick();

        // Step 3: Clean up existing instances
        if (this.wavesurfer) {
          this.wavesurfer.destroy();
          this.wavesurfer = null;
          this.recordPlugin = null;
        }

        // Step 4: Verify waveform container exists
        if (!this.$refs.waveform) {
          throw new Error('Waveform container ref not found in DOM');
        }

        // Step 5: Create WaveSurfer instance
        this.wavesurfer = globalThis.WaveSurfer.create({
          container: this.$refs.waveform,
          waveColor: '#3B82F6',
          progressColor: '#1D4ED8',
          cursorColor: '#1D4ED8',
          barWidth: 3,
          barGap: 2,
          barRadius: 3,
          height: 60,
          normalize: true,
          responsive: true,
        });

        // Step 6: Verify RecordPlugin is available
        const RecordPlugin = this.getWaveSurferRecordPlugin();
        if (!RecordPlugin) {
          throw new Error('RecordPlugin class not available. Please refresh the page.');
        }

        // Step 7: Register and create record plugin
        this.recordPlugin = this.wavesurfer.registerPlugin(
          RecordPlugin.create({
            renderRecordedAudio: false,
            scrollingWaveform: true,
            mimeType: 'audio/webm',
          })
        );

        // Step 8: Verify plugin was created
        if (!this.recordPlugin) {
          throw new Error('Record plugin registration returned null');
        }

        // Step 9: Set up event listeners
        this.recordPlugin.on('record-end', (blob) => {
          this.recordedBlob = blob;
          this.handleRecordingComplete(blob);
        });

        this.recordPlugin.on('record-progress', (time) => {
          // Update progress if needed
        });

        console.log('✓ Event listeners attached');

        // Step 10: Start recording
        console.log('Starting recording...');
        await this.recordPlugin.startRecording();
        console.log('✓ Recording started successfully!');

        // Step 11: Start duration timer
        this.recordingTimer = setInterval(() => {
          this.recordingDuration++;
        }, 1000);
        console.log('✓ Timer started');

      } catch (error) {
        console.error('❌ Error in startRecording:', error);
        console.error('Error stack:', error.stack);

        // Reset state
        this.isRecording = false;

        // Clean up
        if (this.recordingTimer) {
          clearInterval(this.recordingTimer);
          this.recordingTimer = null;
        }

        if (this.wavesurfer) {
          try {
            this.wavesurfer.destroy();
          } catch (e) {
            console.error('Error destroying wavesurfer:', e);
          }
          this.wavesurfer = null;
          this.recordPlugin = null;
        }

        // Show user-friendly error
        this.$swal.fire({
          icon: 'error',
          title: this.$t('recordingError'),
          text: error.message || this.$t('_couldNotStartRecording'),
          showConfirmButton: true
        });
      }
    },


    async stopRecording() {
      try {
        console.log('Stopping recording...');

        if (this.recordPlugin) {
          await this.recordPlugin.stopRecording();
          console.log('✓ Recording stopped');
        }

        // Clear timer
        if (this.recordingTimer) {
          clearInterval(this.recordingTimer);
          this.recordingTimer = null;
        }

        this.isRecording = false;

      } catch (error) {
        console.error('Error stopping recording:', error);
        this.isRecording = false;

        // Clean up timer anyway
        if (this.recordingTimer) {
          clearInterval(this.recordingTimer);
          this.recordingTimer = null;
        }
      }
    },

    handleRecordingComplete(blob) {
      console.log('Recording complete:', {
        size: blob.size,
        type: blob.type,
        duration: this.recordingDuration
      });

      // Convert blob to file
      const file = new File([blob], `recording_${Date.now()}.webm`, {
        type: blob.type
      });

      console.log('File created:', file);

      // Show success message
      this.$swal.fire({
        icon: 'success',
        title: this.$t('recordingSaved'),
        text: this.$t('_recordingDuration', { duration: this.formatRecordingTime(this.recordingDuration) }),
        timer: 2000,
        showConfirmButton: false
      });

      // Process or upload the audio file here //NOSONAR
      // Example: this.uploadAudioFile(file);

      // Clean up WaveSurfer instance
      this.destroyWavesurfer();
    },

    destroyWavesurfer() {
      if (this.wavesurfer) {
        try {
          this.wavesurfer.destroy();
        } catch (e) {
          console.error('Error destroying wavesurfer:', e);
        }
        this.wavesurfer = null;
        this.recordPlugin = null;
      }
    },

    blockNegative(e) {
      if (e.key === '-' || e.key === 'e' || e.key === '+') {
        e.preventDefault();
      }
    },
    handleAttachmentItemClick(itemId) {
      switch (itemId) {
        case 'images':
          // Trigger the image DragDropFile component
          if (this.$refs.imageDragDrop) {
            this.$refs.imageDragDrop.$el.querySelector('input[type="file"]')?.click();
          }
          break;
        case 'files':
          // Trigger the file DragDropFile component
          if (this.$refs.fileDragDrop) {
            this.$refs.fileDragDrop.$el.querySelector('input[type="file"]')?.click();
          }
          break;
        default:
          console.warn('Unknown attachment type:', itemId);
      }
    },
    createDefaultRequestVector(fileId = -1) {
      return {
        modelType: null,
        modelId: null,
        vectordbName: null,
        entity: null,
        deleteAll: false,
        groupReplaceID: null,
        customCharacter: null,
        DetectLanguage: true,
        USER_CHANNEL: null,
        TopicID: null,
        // topVDB: null,
        topVDB: 3,
        // cosine: null,
        cosine: -1,
        fileId: fileId,
        MaxLimitedCharacter: null
      };
    },

    processUploadFile(files) {

      if (files.length === 0) {
        return;
      }
      let fileUploadSizeLimit = 4 * 1024 * 1024; // 4 MB
      if (files[0].size > fileUploadSizeLimit) {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('fileTooLarge4MB'),
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      this.ClearValuePrivate_Memory();
      if (this.KeyTopic == null) {
        this.KeyTopic = this.GetUuidv4_Fun();
      }
      this.requestVector = this.createDefaultRequestVector();

      this.requestVector.searchVectorDBName2 = "";
      this.actionEdit = true;
      this.searchtext_org = null;

      // Determine file type based on MIME type
      let documentType = 1; // Default to CSV
      const file = files[0];
      const mimeType = file.type;

      // Map MIME types to document types
      if (mimeType === 'text/csv') {
        documentType = 1; // CSV
      } else if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        mimeType === 'application/vnd.ms-excel') {
        documentType = 2; // Excel
      } else if (mimeType === 'application/pdf') {
        documentType = 3; // PDF
      } else if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        mimeType === 'application/msword') {
        documentType = 4; // Word
      } else if (mimeType === 'text/plain') {
        documentType = 5; // Text
      } else if (mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
        mimeType === 'application/vnd.ms-powerpoint') {
        documentType = 6; // PowerPoint
      } else {
        documentType = 7; // Unknown
      }

      this.requestVector.MaxLimitedCharacter = 5500;
      this.requestVector.doctype = documentType;
      this.requestVector.vectortype = 1;
      this.requestVector.modelType = 1;

      this.files = files;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]); //NOSONAR
      reader.onload = () => {
        const formDataDoc = new FormData();
        formDataDoc.append('entity', this.files[0]);
        this.uploadedFiles = this.files;
        this.requestVector.entity = formDataDoc;
        this.pickedFileName = this.files[0].name;
        this.pickedFileType = this.GetFileTypeImg(documentType);
        this.SaveFile();
      };
    },
    ClearUploadedFile() {
      this.pickedFileType = null;
      this.pickedFileName = null;
      this.requestVector.entity = null;
      this.uploadFileComplete = false;
      this.uploadedFiles = [];
      this.files = [];
      this.dataAll = 0;
      this.dataUpdate = 0;
      this.fileID = -1;
    },
    getChatImageAuthToken() {
      return null;
    },
    onPaste(event) {
      if (!this.IsAllowImage)
        return

      const item = event.clipboardData.items[0]; // เอาเฉพาะ index แรก

      if (item && item.type.startsWith('image')) {

        const file = item.getAsFile();

        const filesArray = [file];
        this.ValidateImage(filesArray);
        const reader = new FileReader();

        reader.onload = (e) => {
          this.fileDataUrl = e.target.result;
          this.ValidateImage(filesArray);
          this.UploadImage()
        };

        reader.readAsDataURL(file);
        event.preventDefault(); // ป้องกันการวางค่าอื่น ๆ
      } else {
        console.log('Not an image or unsupported content');
      }
    },
    confirmSwal(titleAlert, textAlert) {
      return this.$swal.fire({
        title: titleAlert,
        text: textAlert,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: false,
      });
    },
    PrivateVectorOnOffByFileID(item) {
      const titleAlert = item.isActive ? this.$t('confirmOn') : this.$t('confirmOff');
      const textAlert = item.isActive ? this.$t('confirmOnVectorName') : this.$t('confirmOffVectorName');
      this.confirmSwal(titleAlert, textAlert)
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              fileID: item.fileId,
              activeFlag: item.isActive,
            };
            this.dialog = true;
            try {
              this.$call.PrivateVectorOnOffByFileID_Stream(
                temp,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  item.isActive = !item.isActive;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, 'DeleteGroup');
            }
          } else {
            item.isActive = !item.isActive;
          }
        });
    },
    VectorOnOff(item) {
      const titleAlert = item.activeFlag ? this.$t('confirmOn') : this.$t('confirmOff');
      const textAlert = item.activeFlag ? this.$t('confirmOnVectorName') : this.$t('confirmOffVectorName');
      this.confirmSwal(titleAlert, textAlert)
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              fileID: item.fileId,
              id: item.id,
              activeFlag: item.activeFlag,
            };
            this.dialog = true;
            try {
              this.$call.PrivateVectorOnOff_Stream(
                temp,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  item.activeFlag = !item.activeFlag;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, 'DeleteGroup');
            }
          } else {
            item.activeFlag = !item.activeFlag;
          }
        });
    },
    async changeRestoreNewVersion(id, fileId) {
      this.loading = true;
      let req = {
        ID: id,
        fileId: fileId,
      };
      this.$call.SaveReStorePrivateVector_Stream(
        req,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.GetListFile_PrivateMemoryStream("OpenPopPrivateMemoryDialog_ListFile");
          }
          this.dialog_version = false;
          this.loading = false;
          return null;
        },
        (errorResource) => {
          this.loading = false;
          this.isSearch = false;
          this.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async Version(fileId) {
      this.loading = true;
      this.fileID = fileId;

      if (!this.dialog_version) {
        this.options_version.page = 1;
      }

      this.dialog_version = true;

      const { page } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: 5,
        fileId: fileId,
      };

      this.$call.GetTablePrivateVectorVersion_Stream(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.menus_version = dataResponse.data.data;
            this.searchTotalTable_version = dataResponse.data.total;
            this.totalTable_version = dataResponse.data.total;
          } else {
            this.menus_version = [];
            this.searchTotalTable_version = 0;
            this.totalTable_version = 0;
          }
          this.loading = false;
        },
        (errorResource) => {
          this.loading = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    async viewVersion(id, fileId, keytopic) {
      this.dialog_view_private = true;
      this.loading = true;
      this.privateID = id;
      this.fileID = fileId;
      this.temKeytopic = keytopic;
      const { page, itemsPerPage } = this.options_view_private;
      this.sortBy = this.options_view_private.sortBy.length == 0 ? null : this.options_view_private.sortBy[0];
      this.sortDesc = this.options_view_private.sortDesc.length == 0 ? null : this.options_view_private.sortDesc[0];

      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? null : itemsPerPage,
        id: id,
        FileId: fileId,
        name: keytopic,
        text_org: null,
        sortDesc: this.sortDesc,
        sortBy: this.sortBy,
      }
      await this.$call.ReFreshPrivateVector_Stream(
        temp,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.view_private_version = dataResponse.data.table.data;
            this.searchTotalTable_view_private = dataResponse.data.table.total;
            this.totalTable_view_private = dataResponse.data.table.total;
          } else {
            this.view_private_version = [];
            this.searchTotalTable_view_private = 0;
            this.totalTable_view_private = 0;
          }
          this.isSearch = false;
          this.loading = false;
        },
        (errorResource) => {
          this.loading = true;
          this.dialog_view_private = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    OpenPopup_Private_Memory(item) {
      this.ClearValuePrivate_Memory();
      if (item == null) {
        this.requestVector = this.createDefaultRequestVector();
        this.requestVector.searchVectorDBName2 = "";
        this.requestVector.MaxLimitedCharacter = this.MaxLimitedCharacter;
        this.actionEdit = false;
        this.requestVector.modelType = null;
        this.searchtext_org = null;
        // this.requestVector = {
        //   modelType: null,
        //   modelId: null,
        //   vectordbName: null,
        //   entity: null,
        //   deleteAll: false,
        //   groupReplaceID: null,
        //   customCharacter: null,
        //   DetectLanguage: true,
        //   USER_CHANNEL: null,
        //   TopicID: null,
        //   // topVDB: null,
        //   topVDB: 3,
        //   // cosine: null,
        //   cosine: -1,
        //   fileName: "",
        //   fileId: -1
        // }

        this.dataTable = [];
        this.searchTotalTable = 0;
        this.totalTable = 0;
        this.actionEdit = false;


        this.loadingTable = false;
        this.isSearch = false;
        this.isFirst = false;
        this.showTable = true;


      }
      else {
        this.requestVector = this.createDefaultRequestVector(item.fileId);

        this.requestVector.searchVectorDBName2 = item.fileName;
        this.actionEdit = true;
        this.searchtext_org = null;
        this.ReFresh();
        this.GetByVector();

      }
      this.PrivateMemoryDialog = true;
    },

    numericKey: function (evt) {
      evt = evt || window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*(?:\.\d*)?$/.test(expect) || Number.parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F]+$/;

      if (validCharactersRegex.test(String.fromCodePoint(charCode))) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    GetMaxLimitedCharacter() {
      this.dialog = true;
      this.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.MaxLimitedCharacter = dataResponse.data;
          } else {
            this.MaxLimitedCharacter = this.requestVector.MaxLimitedCharacter;
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    formatText(text) {
      // แปลงช่องว่างเป็น &nbsp; เพื่อให้รักษาช่องว่างได้
      return text.replaceAll(' ', '&nbsp;');
    },
    checkCustomCharacterValidate() {
      if (this.requestVector.modelType == 3 && (this.requestVector.customCharacter == '' || this.requestVector.customCharacter == null)) {
        return "Required.";
      } else {
        this.customCharacter = null;
      }
      return true;
    },

    TemplateVectorDialog() {
      this.TemplateVector = true;
    },
    linkDownload(modelType, filename) {
      let req = {
        modelType: modelType,
        filename: filename
      }
      this.$call.DownloadTemplateVector_Stream(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = globalThis.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `Template_${modelType}_${filename}${this.findTypeName(filename)}`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          this.TemplateVector = false;
        },
        (errorResource) => {
          this.TemplateVector = false;
          console.error(errorResource);
        }
      );
    },
    findTypeName(filename) {
      let type = ""
      switch (filename) {
        case "CSV":
          type = ".csv";
          break;
        case "Excel":
          type = ".xlsx";
          break;
        case "ExcelMultiColumn":
          type = ".xlsx";
          break;
        case "PDF":
          type = ".pdf";
          break;
        case "Word":
          type = ".docx";
          break;
        case "Text":
          type = ".txt";
          break;
        case "PowerPoint":
          type = ".pptx";
          break;
      }
      return type;
    },
    setTypeFile(val) {
      switch (val) {
        case 1:
          this.accept = '.csv';
          break;
        case 2:
          this.accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          break;
        case 3:
          this.accept = 'application/pdf';
          break;
        case 4:
          this.accept = '.doc, .docx, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        case 5:
          this.accept = 'text/plain';
          break;
        case 6:
          this.accept = '.ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation';
          break;
        default:
          this.accept = '';
          break;
      }
    },
    GetDDGroupReplaceDB_Stream() {
      this.dialog = true;
      this.$call.GetDDGroupReplaceDB_Stream(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDGroupReplace = dataResponse.data;
          } else {
            this.DDGroupReplace = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    AddVectorperChunk() {
      this.AddVector = true;
      this.Add.textORG = null;
    },
    EditVectorperChunk(item) {
      this.EditVector = true;
      this.Edit.id = item.id;
      this.Edit.textORG = item.textORG;
    },
    SaveEdit() {
      if (!this.Edit.textORG) {
        alert(this.$t('_pleaseFillAllFields'));
        return;
      }
      let temp = {
        ID: this.Edit.id,
        Content: this.Edit.textORG,
        MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
        groupReplaceID: this.tempgroupReplaceID == null ? null : JSON.stringify(this.tempgroupReplaceID),
        DetectLanguage: this.requestVector.DetectLanguage,
      };
      this.dialog = true;
      try {
        this.$call.SaveEditVector_Stream(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });

              this.GetByVector();
              this.closeUploaddialog();
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) { //NOSONAR

        console.log('catch : DeleteGroup');


      }
    },


    closeUploaddialog() {
      this.EditVector = false;
      this.Edit.id = null;
      this.Edit.textORG = null;
    },

    Delete_ListFilePM_ById_Stream(id) {
      try {
        this.confirmSwal(this.$t('confirmDeletion'), this.$t('confirmDeletionVector'))
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;
              this.$call.Delete_ListFilePM_ById_Stream(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.GetListFile_PrivateMemoryStream("");
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) { //NOSONAR

        console.log('catch : DeleteGroup');
      }
    },
    DeleteById(id) {
      try {
        this.confirmSwal(this.$t('confirmDeletion'), this.$t('confirmDeletionVector'))
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;
              this.$call.DeleteVectorDBNameById_Stream(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.GetByVector();
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) { //NOSONAR

        console.log('catch : DeleteGroup');
      }
    },
    DeleteByName(name_data) {
      try {
        this.confirmSwal(this.$t('confirmDeletion'), this.$t('confirmDeletionVectorName'))
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;

              let DataName_FileId = {
                name: name_data,
                FileId: this.requestVector.fileId
              }
              this.$call.DeleteVectorDBNameByName_Stream(
                DataName_FileId,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.dataUpdate = 0;
                    this.dataAll = 0;
                    this.actionEdit = false;
                    this.requestVector.searchVectorDBName2 = null;
                    this.GetByVector();
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) { //NOSONAR

        console.log('catch : DeleteGroup');
      }
    },
    processUploadImage(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestUpload.entity = null;
        this.uploadedFiles = [];
        return;
      }
      if (this.FileUploadLimit != null && this.FileUploadLimit != "" && this.FileUploadLimit != undefined && this.FileUploadLimit != 0) {
        const maxSize = this.FileUploadLimit * 1024; // this.FileUploadLimit KB
        if (this.files[0].size > maxSize) {
          this.$swal.fire({
            icon: 'error',
            title: this.$t('_fileTooLargeKB', { limit: this.FileUploadLimit }),
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }
      else {
        const maxSize = 2048 * 1024; // 2048 KB
        if (this.files[0].size > maxSize) {
          this.$swal.fire({
            icon: 'error',
            title: this.$t('_fileTooLargeKB', { limit: 2048 }),
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }
      const file = e[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.fileDataUrl = e.target.result;
        this.ValidateImage(this.files);
        this.UploadImage()
      };
      reader.readAsDataURL(file);
    },
    ValidateImage(files) {
      const formDataDoc = new FormData();
      formDataDoc.append('entity', files[0]);
      this.uploadedFiles = files;
      this.requestUpload.entity = formDataDoc;
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]); //NOSONAR
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
        this.ConfirmProcess();
      };
    },
    ValidateCSVVector(csv, files) {
      const formDataDoc = new FormData();
      formDataDoc.append('entity', files[0]);
      this.uploadedFiles = files;
      this.requestVector.entity = formDataDoc;
    },
    ConfirmProcess() {
      this.$swal
        .fire({
          icon: 'warning',
          title: this.$t('importPrivate_MemoryTitle'),
          // text: "คุณต้องการนำเข้า Vector",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.Save();
          }
        });
    },
    UploadImage() {
      if (!this.requestUpload.entity) {
        alert(this.$t('_pleaseFillAllFields'));
        return;
      }


      this.requestUpload.USER_CHANNEL = this.User_Id;

      this.loadingImage = true;
      try {
        this.$call.UploadImage_Stream(
          this.requestUpload,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.ImageURL = dataResponse.data;
              this.requestUpload.entity = null;
              this.uploadedFiles = [];
            }
            else {
              this.$swal.fire({
                icon: 'error',
                title: this.$t('errorUploadImage'),
                showConfirmButton: false,
                timer: 2500,
              });
              this.ClearImage();
            }
            this.loadingImage = false;
          },
          (errorResource) => {
            this.$swal.fire({
              icon: 'error',
              title: this.$t('errorUploadImage'),
              showConfirmButton: false,
              timer: 2500,
            });
            this.loadingImage = false;
            this.ImageURL = null;
            this.fileDataUrl = null;
            this.requestUpload.entity = null;
            console.error(errorResource);
          }
        );
      } catch (error) { //NOSONAR
        this.GetTopicStream("Start");

        console.log('catch : DeleteGroup');
      }
    },
    ClearImage() {
      this.ImageURL = null;
      this.fileDataUrl = null;
      this.loadingImage = false;
      this.requestUpload.entity = null;
      this.uploadedFiles = [];
    },
    Save() {
      if (!this.requestVector.modelType || !this.KeyTopic || !this.requestVector.entity
        || !this.requestVector.topVDB) {
        alert(this.$t('_pleaseFillAllFields'));
        return;
      }
      if (this.requestVector.modelType == 3 && !this.requestVector.customCharacter) {
        alert(this.$t('_pleaseFillAllFields'));
        return;
      }
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == "" || this.requestVector.MaxLimitedCharacter == undefined) {
        alert(this.$t('pleaseFillCustomMaxChar'));
        return;
      }
      this.requestVector.searchVectorDBName2 = (this.requestVector.searchVectorDBName2 == null ? "" : this.requestVector.searchVectorDBName2);
      if (this.requestVector.searchVectorDBName2 == "" || this.requestVector.searchVectorDBName2.replaceAll(' ', '') == "") {

        if (this.uploadedFiles != null && this.uploadedFiles.length > 0) {

          const indexLast_Name_uploadedFiles = this.uploadedFiles[0].name.lastIndexOf(".");

          this.requestVector.searchVectorDBName2 = this.uploadedFiles[0].name.substring(0, (indexLast_Name_uploadedFiles == -1 ? this.uploadedFiles[0].name.length : indexLast_Name_uploadedFiles));
        }

      }

      this.requestVector.vectordbName = this.KeyTopic;

      this.requestVector.USER_CHANNEL = this.User_Id;
      this.requestVector.TopicID = this.Log_History_TopicID;
      this.dialog = true;
      try {
        this.requestVector.groupReplaceID = this.tempgroupReplaceID == null ? null : JSON.stringify(this.tempgroupReplaceID);
        this.$call.UploadCSV2Vector_Stream(
          this.requestVector,
          (dataResponse) => {
            this.GetTopicStream("Start");
            if (dataResponse.status == 0) {
              this.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.KeyTopic = this.requestVector.vectordbName;
              this.requestVector.entity = null;
              this.showTable = true;
              this.actionEdit = true;
              this.flagNew = false;
              this.uploadedFiles = [];
              this.requestVector.fileId = dataResponse.data.fileId;
              this.GetByVector();
            }
            this.dialog = false;
          },
          (errorResource) => {

            this.GetTopicStream("Start");
            // }
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) { //NOSONAR
        this.GetTopicStream("Start");

        console.log('catch : DeleteGroup');
      }
    },
    SaveFile() {
      this.requestVector.modelType = 1;

      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == "" || this.requestVector.MaxLimitedCharacter == undefined) {
        alert(this.$t('pleaseFillCustomMaxChar'));
        return;
      }

      this.requestVector.fileName = this.GetUuidv4_Fun();
      this.requestVector.searchVectorDBName2 = this.GetUuidv4_Fun();
      this.requestVector.vectordbName = this.KeyTopic;

      this.requestVector.USER_CHANNEL = this.User_Id;
      this.requestVector.TopicID = this.Log_History_TopicID;
      this.dialog = true;
      try {
        this.requestVector.groupReplaceID = this.tempgroupReplaceID == null ? null : JSON.stringify(this.tempgroupReplaceID);
        this.requestVector.fileId = -1;
        this.requestVector.deleteAll = false;
        this.$call.UploadCSV2Vector_Stream(
          this.requestVector,
          (dataResponse) => {


            if (dataResponse.status == 0) {

              this.KeyTopic = this.requestVector.vectordbName;
              this.requestVector.entity = null;
              this.showTable = true;
              this.actionEdit = true;
              this.flagNew = false;
              this.uploadedFiles = [];
              this.requestVector.fileId = dataResponse.data.fileId;
              this.GetByVector();
            }
            this.dialog = false;
          },
          (errorResource) => {

            this.GetTopicStream("Start");

            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) { //NOSONAR

        this.GetTopicStream("Start");


        console.log('catch : DeleteGroup');
      }
    },
    ClearValuePrivate_Memory() {

      this.showTable = false;

      this.requestVector.entity = null;
      this.requestVector.modelId = null;
      this.requestVector.searchVectorDBName2 = null;
      this.tempgroupReplaceID = null;
      this.doctype = null;
      this.vectortype = null;
      this.requestVector.modelType = null;
      this.requestVector.customCharacter = null;
      this.requestVector.DetectLanguage = true;



      this.dataTable = [];
      this.searchTotalTable = 0;
      this.totalTable = 0;



      this.dataUpdate = 0;
      this.dataAll = 0;
      this.exceptionFlag = false;


      this.loadingTable = false;
      this.isSearch = false;
      this.showTable = true;
      this.options = { "page": 1, "itemsPerPage": this.itemsPerPage, "sortBy": [], "sortDesc": [false], "groupBy": [], "groupDesc": [], "mustSort": false, "multiSort": false };

      this.sortBy = [];
      this.sortDesc = [];
      if (this.Axios_VECTOR != null) {
        this.Axios_VECTOR.abort();
      }
    },

    GetByVector() {
      this.$nextTick(() => {
        if (this.requestVector.fileId == null || this.requestVector.fileId == -1 || this.requestVector.fileId == "") {
          this.flagNew = true;
          return;
        }
        this.loadingTable = true;
        let { page, itemsPerPage } = this.options;

        this.sortBy = (this.options.sortBy.length == 0 ? null : this.options.sortBy[0]);
        this.sortDesc = (this.options.sortDesc.length == 0 ? null : this.options.sortDesc[0]);

        let temp = {
          page: this.isSearch ? 1 : page,
          perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
          name: this.KeyTopic,
          fileId: this.requestVector.fileId,
          sortDesc: this.sortDesc,
          sortBy: this.sortBy
        };

        this.Axios_VECTOR = new AbortController();

        let Config = {
          signal: this.Axios_VECTOR.signal
        }

        this.$call.ReFreshVector_Stream(temp, Config, (dataResponse) => {
          if (dataResponse.status == 0) {
            this.dataUpdate = dataResponse.data.dataUpdate;
            this.dataAll = dataResponse.data.dataAll;
            this.exceptionFlag = dataResponse.data.exceptionFlag;
            this.searchTotalTable = dataResponse.data.table.total;
            this.dataTable = dataResponse.data.table.data;
            this.totalTable = dataResponse.data.table.total;
            this.tempgroupReplaceID = dataResponse.data.groupReplaceID;

            if (this.$route.query.name) {
              this.requestVector.customCharacter = dataResponse.data.customCharacter;
              this.requestVector.modelType = dataResponse.data.modelType;
              this.requestVector.DetectLanguage = dataResponse.data.detectLanguage;
              this.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
            }
            this.AutoRefresh();
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
            this.actionEdit = false;
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.showTable = true;
          this.dataTable.forEach(element => {
            element.show = this.showAllText;
          });
        },
          (errorResource) => {
            this.loadingTable = false;
            this.isSearch = false;
            console.error(errorResource);
          });
      });
    },
    ReProcess() {
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == "" || this.requestVector.MaxLimitedCharacter == undefined) {
        alert(this.$t('pleaseFillCustomMaxChar'));
        return;
      }
      this.$swal
        .fire({
          icon: 'warning',
          title: this.$t('vectorReprocess'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              let data = {
                VectordbName: this.KeyTopic,
                FileId: this.requestVector.fileId,
                MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
                groupReplaceID: this.tempgroupReplaceID == null ? null : JSON.stringify(this.tempgroupReplaceID),
                DetectLanguage: this.requestVector.DetectLanguage
              };
              this.$call.ReProcessedVector_Stream(
                data,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    this.GetByVector();
                  }
                },
                (errorResource) => {
                  console.error(errorResource.message);
                }
              );
            } catch (error) { //NOSONAR

              console.log('catch : ReProcess');
            }
          }
        });
    },
    ReFresh() {
      try {
        if ((this.KeyTopic != null && this.KeyTopic != '')) {
          let { page, itemsPerPage } = this.options;
          this.sortBy = this.options.sortBy.length == 0 ? null : this.options.sortBy[0];
          this.sortDesc = this.options.sortDesc.length == 0 ? null : this.options.sortDesc[0];
          let temp = {
            page: this.isSearch ? 1 : page,
            // perPage: itemsPerPage != -1 ? itemsPerPage : this.totalTable,
            perPage: itemsPerPage == -1 ? null : itemsPerPage,
            name: this.KeyTopic,
            TopicID: this.Log_History_TopicID,
            fileId: this.requestVector.fileId,
            text_org: this.searchtext_org,
            sortDesc: this.sortDesc,
            sortBy: this.sortBy,
          };
          this.Axios_VECTOR = new AbortController();

          let Config = {
            signal: this.Axios_VECTOR.signal
          }

          this.$call.ReFreshVector_Stream(temp, Config,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.dataUpdate = dataResponse.data.dataUpdate;
                this.dataAll = dataResponse.data.dataAll;
                this.exceptionFlag = dataResponse.data.exceptionFlag;
                this.searchTotalTable = dataResponse.data.table.total;
                this.dataTable = dataResponse.data.table.data;
                this.totalTable = dataResponse.data.table.total;
                this.modelType = dataResponse.data.modelType;
                this.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
                if (this.dataUpdate == this.dataAll) {
                  this.uploadFileComplete = true;
                }
              }
              this.totalTable = this.totalTable + 1;
              this.isSearch = false;

            },
            (errorResource) => {
              this.isSearch = false;
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) { //NOSONAR

        console.log('catch : ReFresh');
      }
    },
    async AutoRefresh() {
      let death_waiting = true;
      do {
        if ((this.KeyTopic != null && this.KeyTopic != '')) {
          if (this.dataUpdate == this.dataAll || this.exceptionFlag) death_waiting = false;
          else this.ReFresh();
        }
        console.log('Wait for 5 seconds!');
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    closeUploaddialogAdd() {
      this.AddVector = false;
      this.Add.id = null;
      this.Add.textORG = null;
    },

    SaveAdd() {


      const modelTypeDefault = this.modelType == null ? 1 : this.modelType;
      this.requestVector.modelType = this.requestVector.modelType == null || !this.requestVector.modelType ? modelTypeDefault : this.requestVector.modelType;

      if (!this.Add.textORG || !this.requestVector.modelType || !this.requestVector.searchVectorDBName2) {
        alert(this.$t('_pleaseFillAllFields'));
        return;
      }
      if (this.requestVector.modelType == 3 && !this.requestVector.customCharacter) {
        alert(this.$t('_pleaseFillAllFields'));
        return;
      }
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == "" || this.requestVector.MaxLimitedCharacter == undefined) {
        alert(this.$t('pleaseFillCustomMaxChar'));
        return;
      }
      this.requestVector.searchVectorDBName2 = (this.requestVector.searchVectorDBName2 == null ? "" : this.requestVector.searchVectorDBName2);
      if (this.requestVector.searchVectorDBName2 == "" || this.requestVector.searchVectorDBName2.replaceAll(' ', '') == "") {

        this.requestVector.searchVectorDBName2 = (this.Add.textORG == null ? "" : this.Add.textORG);

      }
      this.requestVector.vectordbName = this.KeyTopic;

      let temp = {
        vectordbName: this.requestVector.vectordbName,
        modelType: this.requestVector.modelType,
        DetectLanguage: this.requestVector.DetectLanguage,
        groupReplaceID: this.tempgroupReplaceID == null ? null : JSON.stringify(this.tempgroupReplaceID),
        Content: this.Add.textORG,
        flagNew: this.flagNew,
        customCharacter: this.requestVector.customCharacter,
        USER_CHANNEL: this.User_Id,
        TopicID: this.Log_History_TopicID,
        topVDB: this.requestVector.topVDB,
        cosine: this.requestVector.cosine,
        fileId: this.requestVector.fileId,
        fileName: this.requestVector.searchVectorDBName2,
        MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
      };
      this.dialog = true;

      try {
        this.$call.SaveAddVector_Stream(
          temp,
          (dataResponse) => {

            if (dataResponse.status == 0) {
              this.GetTopicStream("Start");
              this.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.showTable = true;
              this.actionEdit = true;
              this.flagNew = false;
              this.GetByVector();
              this.closeUploaddialogAdd();

              this.requestVector.fileId = dataResponse.data.fileId;

            } else {
              this.GetTopicStream("Start");
              // }
              this.VectorDBNameDuplicate = this.KeyTopic;
              this.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.GetTopicStream("Start");
            // }
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.GetTopicStream("Start");
        // }
        this.LogTrace(error, 'DeleteGroup');

      }
    },
    Search() {
      this.isSearch = true;
      this.options.page = 1;
      this.ReFresh()
    },
    ShowAll() {
      this.showAllText = !this.showAllText;
      this.dataTable.forEach(element => {
        element.show = this.showAllText;
      });

    },
    CloseShowAll() {
      this.showAllText = !this.showAllText;
      this.dataTable.forEach(element => {
        element.show = this.showAllText;
      });
    },
    checkValidate() {
      if (this.requestVector.searchVectorDBName2 == '' || this.requestVector.searchVectorDBName2 == null) {
        return "Required.";
      } else if (this.VectorDBNameDuplicate == this.requestVector.searchVectorDBName2) {
        return "Duplicate.";
      }

      return true;
    },

    SaveCosine_TopVDB() {
      try {
        let _Data = {
          TopicName: "Private Memory",
          KeyTopic: this.KeyTopic,
          TopicID: this.Log_History_TopicID,
          topVDB: this.requestVector.topVDB,
          cosine: this.requestVector.cosine,
          USER_CHANNEL: this.User_Id,
        };

        this.$call.SaveCosine_TopVDBStream(_Data, (Response) => {
          if (Response.status == 0 && Response.data != null) {
            this.GetTopicStream("Start");
          }
          this.PrivateMemoryDialog = false;

        },
          () => {
            console.log("catch");
            this.PrivateMemoryDialog = false;

          }
        );
      }
      catch {
        console.log("catch");
        this.PrivateMemoryDialog = false;
      }
    },
    SaveFileName_PrivateMemoryStream() {
      try {
        let _Data = {
          FileId: this.requestVector.fileId,
          USER_CHANNEL: this.User_Id,
          FileName: this.requestVector.searchVectorDBName2,
        };
        this.$call.SaveFileName_PrivateMemoryStream(_Data, (Response) => {

          if (Response.status == 0 && Response.data != null) {
            this.GetListFile_PrivateMemoryStream("");
          }
          this.PrivateMemoryDialog = false;

        },
          () => {
            console.log("catch");
            this.PrivateMemoryDialog = false;

          }
        );
      }
      catch {
        console.log("catch");
        this.PrivateMemoryDialog = false;
      }
    },

    CloseFileName_PrivateMemory() {
      try {
        let _Data = {
          FileId: this.requestVector.fileId,
          USER_CHANNEL: this.User_Id,
          FileName: this.requestVector.fileName
        };

        this.$call.CancelFileName_PrivateMemory(_Data, (Response) => {
          if (Response.status == 0 && Response.data != null) {
            this.GetListFile_PrivateMemoryStream("");
          }
          this.PrivateMemoryDialog = false;

        },
          () => {
            console.log("catch");
            this.PrivateMemoryDialog = false;

          }
        );
      }
      catch {
        console.log("catch");
        this.PrivateMemoryDialog = false;
      }
    },

    // CloseFileName_PrivateMemory(){
    //     var that = this;
    //     that.GetListFile_PrivateMemory("");
    //     that.PrivateMemoryDialog = false;
    // },

    GetListFile_PrivateMemoryStream(StatusText) {
      try {
        if ((this.KeyTopic != null && this.KeyTopic != '')) {
          let { page, itemsPerPage } = this.options_ListFilePM;
          let temp = {
            page: this.isSearch_ListFilePM ? 1 : page,
            perPage: itemsPerPage == -1 ? this.totalTable_ListFilePM : itemsPerPage,
            KeyTopic: this.KeyTopic,
            USER_CHANNEL: this.User_Id
          };
          this.$call.GetListFile_PrivateMemoryStream(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {


                this.searchTotalTable_ListFilePM = dataResponse.data.table.total;
                this.dataTable_ListFilePM = dataResponse.data.table.data;
                this.totalTable_ListFilePM = dataResponse.data.table.total;


              }
              if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {

                this.PrivateMemoryDialog_ListFile = true;
              }
            },
            (errorResource) => {
              if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {

                this.PrivateMemoryDialog_ListFile = true;
              }
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) { //NOSONAR


        if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {

          this.PrivateMemoryDialog_ListFile = true;
        }
        console.log('catch : GetListFile_PrivateMemoryStream');
      }
    },

    SetTimeout(time) {
      return setTimeout(() => {


        this.Click_StopVoice();

        console.log("End : " + new Date().toJSON())
      }, time)
    },
    click_account_voice() {
      if ((this.listMessage.length > 0
        && this.listMessage[this.listMessage.length - 1].status_Process != 'END'
        && this.listMessage[this.listMessage.length - 1].status_Process != 'Stop'
        && this.listMessage[this.listMessage.length - 1].status_Process != 'Error')) {
        return;
      }
      else {

        this.TypeInputAudio = 'M';
        this.Uploaddialog = true;
      }
    },

    click_music_box() {
      if ((this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].status_Process != 'END'
        && this.listMessage[this.listMessage.length - 1].status_Process != 'Stop'
        && this.listMessage[this.listMessage.length - 1].status_Process != 'Error')) {
        return;
      }
      else {

        this.TypeInputAudio = 'F';
        this.Uploaddialog = true;
      }
    },

    Click_StartVoice() {

      /* eslint-disable no-console */

      this.messageData = "";

      let _SpeechSDK = SpeechSDK;
      const audioConfig = _SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();



      const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription(this.$root.SubscriptionKey, this.$root.Region);





      speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1500");


      speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode], "Continuous");

      let autoDetectSourceLanguageConfig = _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([this.LangPop]);

      const recognizer = _SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);
      this.SpeechRecognizer = recognizer;


      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);

      let _temp_text = "";

      let _temp_textOld = "";
      this.SpeechRecognizer.recognizing = (s, e) => {

        if (this.TimeOutStop != null) {

          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
        console.log(`TRANSLATING: Text=${e.result.text}`);


        if (this.listMessage.length > 0) {

          if (this.listMessage[this.listMessage.length - 1].messageBot == "-") {

            this.listMessage[this.listMessage.length - 1].messageBot = "*";
            this.listMessage[this.listMessage.length - 1].messageUser = "";
          }



          this.listMessage[this.listMessage.length - 1].messageUser = _temp_textOld + (
            (_temp_textOld == ""
            ) ? "" : " ") + e.result.text;
        }

      };
      this.SpeechRecognizer.recognized = (s, e) => {


        if (e.result.reason == _SpeechSDK.ResultReason.RecognizedSpeech) {



          if (this.listMessage.length > 0) {

            if (this.listMessage[this.listMessage.length - 1].messageBot == "-") {

              this.listMessage[this.listMessage.length - 1].messageBot = "*";
              this.listMessage[this.listMessage.length - 1].messageUser = "";
            }


            this.listMessage[this.listMessage.length - 1].messageUser = _temp_text + "" + e.result.text;

            _temp_text += "" + e.result.text;

            _temp_textOld = this.listMessage[this.listMessage.length - 1].messageUser;

          }

          console.log(`recognized: Text=${e.result.text}`);
        }
        else if (e.result.reason == _SpeechSDK.ResultReason.NoMatch) {
          console.log("NOMATCH: Speech could not be translated.");

        }
        else {
          console.log("ss " + e.result.reason)
        }
      };

      this.SpeechRecognizer.canceled = (s, e) => {

        console.log("canceled.");

        if (this.TimeOutStop != null) {

          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
      };

      this.SpeechRecognizer.sessionStarted = (s, e) => {

        console.log("sessionStarted.");

        if (this.TimeOutStop != null) {

          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON())

        this.TimeOutStop = this.SetTimeout(this.TimeoutFirst);
      };

      this.SpeechRecognizer.sessionStopped = (s, e) => {
        // จบรอบอัดแล้ว ปล่อย recognizer — ถ้าค้างไว้ StopMessage/Chang_History จะเข้าใจว่ายังอัดอยู่
        // this.SpeechRecognizer อ่านออกมาเป็น reactive proxy ต้อง toRaw ก่อนเทียบ (กันรอบเก่ามาล้างของรอบใหม่)
        if (toRaw(this.SpeechRecognizer) === recognizer) {
          this.SpeechRecognizer = null;
        }

        if (this.TimeOutStop != null) {

          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
        console.log("sessionStopped.");
        if (this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].messageBot == "*") {


          this.messageData = this.listMessage[this.listMessage.length - 1].messageUser;
          if (this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].status_Process == 'VoiceStart') {

            this.listMessage.pop();
          }
          this.SendOpenAi('Click');
        }
        else if (this.listMessage.length > 0) {

          if (this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].status_Process == 'VoiceStart') {

            this.listMessage.pop();
          }

        }
      };

      this.SpeechRecognizer.speechStartDetected = (s, e) => {

        console.log("(StartDetected) SessionId: " + e.sessionId);

        if (this.TimeOutStop != null) {

          clearTimeout(this.TimeOutStop);
        }

      };
      this.SpeechRecognizer.speechEndDetected = (s, e) => {

        console.log("(EndDetected) SessionId: " + e.sessionId);



        if (this.TimeOutStop != null) {

          clearTimeout(this.TimeOutStop);
          this.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON())


        this.TimeOutStop = this.SetTimeout(this.Timeout);

      };

      this.SpeechRecognizer.startContinuousRecognitionAsync((e) => {
        // alert(e)
      }, (error) => {
        // alert(error)
        // เริ่มอัดไม่สำเร็จ ปล่อย recognizer ตรงนี้ด้วย ไม่พึ่งว่า sessionStopped จะถูกเรียก
        if (toRaw(this.SpeechRecognizer) === recognizer) {
          this.SpeechRecognizer = null;
        }

        if (this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].status_Process == 'VoiceStart'
          && error == "Error occurred during microphone initialization: NotAllowedError: Permission denied"
        ) {


          this.listMessage[this.listMessage.length - 1].status_Process = 'END'
          this.listMessage[this.listMessage.length - 1].messageBot = this.$t('noMicPermission');

        }
        else if (this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].status_Process == 'VoiceStart'

        ) {


          this.listMessage[this.listMessage.length - 1].status_Process = 'END'
          this.listMessage[this.listMessage.length - 1].messageBot = this.$t('errorOccurred');

        }
        else {
          this.listMessage.push({
            messageUser: this.$t('speaking'),
            messageBot: this.$t('errorOccurred'),
            status_Process: "END"
          });

        }
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
      });



      if (this.listMessage.length > 0 && this.messageRes.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process == 'END'
      ) {
        if (this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes[this.messageRes.length - 1].length) {
          this.Count_messageRes[this.listMessage.length - 1] = 0;
          this.StatusPro = true;
          this.loading = true;
          this.messageRun = "";
          this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes[this.messageRes.length - 1];
          this.messageRes[this.messageRes.length - 1] = "";
        }
      }


      this.listMessage.push({
        messageUser: this.$t('speaking'),
        messageBot: "-",
        status_Process: "VoiceStart"
      });


    },
    Click_StopVoice() {

      if (this.TimeOutStop != null) {

        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }

      if (this.SpeechRecognizer != null) {
        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
    },



    Convest_Speech_To_Text(Ob_DataFile) {

      let formData = new FormData();
      let OB_DF = Ob_DataFile;

      if (this.listMessage.length > 0 && this.messageRes.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process == 'END'
      ) {
        if (this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes[this.messageRes.length - 1].length) {
          this.Count_messageRes[this.listMessage.length - 1] = 0;
          this.StatusPro = true;
          this.loading = true;
          this.messageRun = "";
          this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes[this.messageRes.length - 1];
          this.messageRes[this.messageRes.length - 1] = "";
        }
      }

      if (OB_DF.Status) {


        this.listMessage.push({
          messageUser: this.$t('audioFile') + " " + OB_DF.NameFile,
          messageBot: "",
          status_Process: "Process"
        });


        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);


      } else {


        this.listMessage.push({
          messageUser: this.$t('audioFile'),
          messageBot: OB_DF.manualContent,
          status_Process: "END"
        });


        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);


        return;
      }


      this.Axios_ControllerAduio = new AbortController();

      let Config = {
        signal: this.Axios_ControllerAduio.signal
      }

      formData.append("FileSoeech", OB_DF.DataFile);
      formData.append("LangPop", this.LangPop);

      this.$call.GetConvest_Speech_To_Text(formData, Config, (response) => {

        if (response.status == 0 && response.data.status == true) { //NOSONAR
          //console.log(response)


          this.listMessage.pop();
          if (response.data.data == "") {

            this.listMessage.push({
              messageUser: this.$t('noAudioDataInFile'),
              messageBot: "",
              status_Process: "END"
            });
          } else {

            this.messageData = response.data.data;




            this.SendOpenAi('Click');

          }
        }
        else if (this.listMessage.length > 0) {

          ///this.listMessage[this.listMessage.length - 1].messageUser = "ไฟล์เสียง";
          this.listMessage[this.listMessage.length - 1].messageBot = response.data.textError;
          this.listMessage[this.listMessage.length - 1].status_Process = "END";
        }
      },
        () => {

          if (this.listMessage.length > 0) {

            this.listMessage[this.listMessage.length - 1].messageBot = this.$t('cannotConvertAudio');
            this.listMessage[this.listMessage.length - 1].status_Process = "END";
          }
        });



    },
    GetUuidv4_Fun() {

      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return Uuid;
    },

    GetUuidv4() {

      let da = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );


      this.User_Id = da;

      this.User_Id_Show = da;
    },
    GetUuidv4_Fun_User_Id_Null() {



      let Uuid = "10000000-1000-4000-8000-100000000000-9000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );

      return Uuid;


    },
    async OpenFullStream() {

      const openFullStreamWithToken = (token, targetWindow = null) => {
        let routeData = this.$router.resolve({ name: 'FullStream', query: { auth_token: token, userId: null } });
        if (targetWindow && !targetWindow.closed) {
          targetWindow.location.href = routeData.href;
          targetWindow.focus();
          return;
        }

        const openedWindow = window.open(routeData.href, '_blank');
        if (!openedWindow) {
          globalThis.location.href = routeData.href;
        }
      };

      const currentToken = this.getCurrentStreamToken();
      if (currentToken) {
        openFullStreamWithToken(currentToken);
        return;
      }


      try {
        const pendingWindow = window.open('', '_blank');
        const tokenReady = await this.GetToken();
        const nextToken = this.getCurrentStreamToken();

        if (tokenReady && nextToken) {
          openFullStreamWithToken(nextToken, pendingWindow);
          return;
        }

        if (pendingWindow && !pendingWindow.closed) {
          pendingWindow.close();
        }
        alert(this.$t('errorOccurred'))
      }
      catch {
        alert(this.$t('errorOccurred'))
      }


    },
    Shift_Enter_MessageData() {


      this.point = this.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = (this.$refs.RefMessageData.$refs.input.selectionStart - 1);


      this.$nextTick(() => {
        this.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        this.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;

        if (this.$refs.RefMessageData.$refs.input &&
          this.$refs.RefMessageData.$refs.input.selectionStart >= this.messageData.length

        ) {

          const height = this.$refs.RefMessageData.$refs.input.scrollHeight


          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          this.$refs.RefMessageData.$refs.input.scrollTop = height;
        }

      })


    },
    Ctrl_Enter_MessageData() {


      this.point = this.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = (this.$refs.RefMessageData.$refs.input.selectionStart - 1);
      if (this.messageData.length > 0) {
        this.messageData = this.messageData.slice(0, _point + 1) + '\n' + this.messageData.slice(_point + 1);
      }
      else {
        this.messageData += '\n';
      }

      this.$nextTick(() => {
        this.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        this.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;

        if (this.$refs.RefMessageData.$refs.input &&
          this.$refs.RefMessageData.$refs.input.selectionStart >= this.messageData.length

        ) {

          const height = this.$refs.RefMessageData.$refs.input.scrollHeight


          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          this.$refs.RefMessageData.$refs.input.scrollTop = height;
        }

      })


    },

    Chang_History() {
      // stop voice
      if (this.TimeOutStop != null) {
        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }
      if (this.SpeechRecognizer != null) {
        this.listMessage.pop();
        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (this.Axios_ControllerAduio != null) {
        this.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (this.Axios_Controller.length != 0) {
        this.Axios_Controller[this.listMessage.length > 0 ? this.listMessage.length - 1 : 0].abort();
      }
      this.Stop_Flag = true;
      this.CountScroll = this.MaxCountScroll;
      this.messageData = "";
      this.messageRes = [];
      this.listMessage = [];
      this.Axios_Controller = [];
      this.Count_messageRes = [];
      this.StatusPro = false;
    },
    StopMessage_TrimTrailingCursor() {
      if (this.listMessage[this.listMessage.length - 1].messageBot.length > 0 && this.listMessage[this.listMessage.length - 1].messageBot.substring(this.listMessage[this.listMessage.length - 1].messageBot.length - 47, this.listMessage[this.listMessage.length - 1].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
        this.listMessage[this.listMessage.length - 1].messageBot = this.listMessage[this.listMessage.length - 1].messageBot.substring(0, this.listMessage[this.listMessage.length - 1].messageBot.length - 47);
      }
    },
    StopMessage_ClearRunningResources() {
      // stop Text_Run
      if (this.TimeOutText_Run != null) {
        clearTimeout(this.TimeOutText_Run);
        this.TimeOutText_Run = null;
      }
      // stop voice
      if (this.TimeOutStop != null) {
        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }
      if (this.SpeechRecognizer != null) {
        // ทิ้งเฉพาะฟอง "Speaking..." ของรอบที่ยังอัดอยู่ ห้าม pop ข้อความอื่น
        if (this.listMessage.length > 0 && this.listMessage[this.listMessage.length - 1].status_Process == 'VoiceStart') {
          this.listMessage.pop();
        }
        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (this.Axios_ControllerAduio != null) {
        this.Axios_ControllerAduio.abort();
      }
      // strp Open ai (ข้อความจากไฟล์เสียงที่ยังแปลงไม่เสร็จไม่มี controller ของตัวเอง)
      if (this.Axios_Controller.length != 0) {
        this.Axios_Controller[this.listMessage.length > 0 ? this.listMessage.length - 1 : 0]?.abort();
      }
    },
    StopMessage_FinalizeEndedResponse() {
      if (this.listMessage.length > 0 && this.messageRes.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process == 'END'
        && this.listMessage[this.listMessage.length - 1].messageBot != null) {
        if (this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes[this.messageRes.length - 1].length) {
          this.Count_messageRes[this.listMessage.length - 1] = 0;
          this.StatusPro = true;
          this.loading = true;
          this.messageRun = "";
          this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes[this.messageRes.length - 1];
          this.messageRes[this.messageRes.length - 1] = "";

          setTimeout(() => {
            this.CountScroll = this.MaxCountScroll;
            this.ChatRef_ScrollIntoView();
          }, 5);
          return true;
        }
      }
      return false;
    },
    StopMessage() {
      if (this.listMessage.length == 0 ||
        (this.listMessage.length > 0 && (
          this.listMessage[this.listMessage.length - 1].status_Process == 'Stop' ||
          this.listMessage[this.listMessage.length - 1].status_Process == 'END' ||
          this.listMessage[this.listMessage.length - 1].status_Process == 'Error')
        )
      ) {
        this.StopMessage_TrimTrailingCursor();
        return;
      }
      this.StopMessage_ClearRunningResources();
      this.Stop_Flag = true;
      // หยุดตรงที่พิมพ์ถึง ไม่เทข้อความที่ยังค้างใน buffer (messageRes) ออกมาให้กระโดดไปข้างหน้า
      if (this.StopMessage_FinalizeEndedResponse()) {
        return;
      }
      if (this.listMessage.length > 0) {
        this.listMessage[this.listMessage.length - 1].status_Process = "Stop";
      }
      this.listMessage[this.listMessage.length - 1].messageBot = this.listMessage[this.listMessage.length - 1].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
      this.messageData = "";
      if (this.messageRes.length > 0) {
        this.messageRes[this.messageRes.length - 1] = "";
      } else {
        this.messageRes[0] = "";
      }

      this.Count_messageRes[this.listMessage.length - 1] = 0;
      this.StatusPro = false;
      this.clearQueue();
    },

    clearQueue() {
      this.messageQueue = [];
      this.isProcessing = false;
    },

    StopMessageByIndex(IndexMessage) {

      if (this.listMessage.length == 0 ||
        (this.listMessage.length > 0 && (
          this.listMessage[IndexMessage].status_Process == 'Stop' ||
          this.listMessage[IndexMessage].status_Process == 'END' ||
          this.listMessage[IndexMessage].status_Process == 'Error')
        )
      ) {
        return;
      }

      // stop Text_Run
      if (this.TimeOutText_Run != null) {

        clearTimeout(this.TimeOutText_Run);
        this.TimeOutText_Run = null;
      }

      // strp Open ai
      if (this.Axios_Controller.length != 0) {
        this.Axios_Controller[IndexMessage].abort();
      }
      if (this.listMessage.length > 0 &&
        this.listMessage[IndexMessage].messageBot.length < this.messageRes[IndexMessage].length) {

        this.listMessage[IndexMessage].messageBot = this.messageRes[IndexMessage];

      }
      //

      if (this.listMessage.length > 0 &&
        this.listMessage[IndexMessage].status_Process == 'END'
        && this.listMessage[IndexMessage].messageBot != null
        && this.listMessage[IndexMessage].messageBot.length < this.messageRes[IndexMessage].length) {

        this.Count_messageRes[this.listMessage.length - 1] = 0;
        this.StatusPro = true;
        this.loading = true;
        this.messageRun = "";
        this.listMessage[IndexMessage].messageBot = this.messageRes[IndexMessage];

        this.messageRes[IndexMessage] = "";

        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);


        return;
      }


      if (this.listMessage.length > 0) {
        this.listMessage[IndexMessage].status_Process = "ChatChain";
      }

      this.listMessage[IndexMessage].messageBot = this.listMessage[IndexMessage].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
    },

    Clear_listMessage() {

      if (this.listMessage.length == 0 || (this.listMessage.length > 0 &&
        (this.listMessage[this.listMessage.length - 1].status_Process == 'Process' ||
          this.listMessage[this.listMessage.length - 1].status_Process == 'Send_Message' ||
          this.listMessage[this.listMessage.length - 1].status_Process == 'VoiceStart'))) {
        return;
      }


      let dataPost = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": this.SessionID,
            "source": this.BuildStreamSource(),
            "message": {
              "id": "325708",
              "type": "text",
              // "text": DataSend
              // "text": "ประวัติประเทศไทย"

              // "topicID": this.Log_History_TopicID,

              "topicModelID": this.TopicModelID_long,
              "topicID": this.Log_History_TopicID,
              "keyTopic": this.KeyTopic,
              "reasoning_effort": this.GetAppliedReasoningEffort(),



              "text": ":clearhistory"
            }
            // ,"stream": true
          }
        ]
      };


      let Config = {
        onUploadProgress: () => {
          console.log("onUploadProgress");
        },
        onDownloadProgress: () => {
          console.log("onDownloadProgress");

        },
        // headers: {
        //   'Content-Length': contentLength
        // },

        maxRedirects: 0 // avoid buffering the entire stream
      }

      this.$call.GptStreamPOST(dataPost, Config, () => {
        this.listMessage = [];
        this.messageData = "";
        if (this.messageRes.length > 0) {
          this.messageRes[this.messageRes.length - 1] = "";
        } else {
          this.messageRes[0] = "";
        }
        this.Count_messageRes[this.listMessage.length - 1] = 0;
        this.StatusPro = false;


        this.DataLog = this.GetLogStream_EmptyDataLog();
        this.clearQueue();

      },
        () => {


        });







    },

    ChatRef_ScrollIntoView() {

      if (this.$refs.ChatScreRef && this.CountScroll >= this.MaxCountScroll &&
        Math.round(this.$refs.ChatScreRef.scrollTop + this.$refs.ChatScreRef.clientHeight) <= this.$refs.ChatScreRef.scrollHeight) {


        this.$refs.ChatRef.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });

        this.CountScroll = 0;
      }



      this.CountScroll++;
    },

    SendOpenAi_ResetDataLog() {
      this.DataLog = this.GetLogStream_EmptyDataLog();
    },

    // Marker helpers moved byte-identical to src/utils/streamMarkdownMarkers.js
    // (shared with Snippet.vue); wrappers keep the existing method names.
    SendOpenAi_ApplyResponseMarkers(_responseText) {
      _responseText = streamMarkdownMarkers.tokenizeCodeFences(_responseText);
      let Sp_RT = _responseText.split("<||");
      return streamMarkdownMarkers.resolveCodeMarkers(_responseText, Sp_RT);
    },

    SendOpenAi_ResolveEndMarker(Sp_RT, I_Sp_RT, Sp_Value, Sp_Value_Old) {
      streamMarkdownMarkers.resolveEndMarker(Sp_RT, I_Sp_RT, Sp_Value, Sp_Value_Old);
    },

    SendOpenAi_ResolveStarAllMarker(Sp_RT, I_Sp_RT, Sp_Value_Old) {
      streamMarkdownMarkers.resolveStarAllMarker(Sp_RT, I_Sp_RT, Sp_Value_Old);
    },

    SendOpenAi_JoinMarkers(Sp_RT) {
      return streamMarkdownMarkers.joinMarkerSegments(Sp_RT);
    },

    SendOpenAi_ExpandMarkers(_responseText) {
      return streamMarkdownMarkers.expandMarkerTokens(_responseText);
    },

    SendOpenAi_FinalizeResponseText(_responseText) {
      _responseText = streamMarkdownMarkers.finalizeMarkdownEscaping(_responseText);
      return streamMarkdownMarkers.injectMarkdownStyleScope(_responseText);
    },

    SendOpenAi_ApplyStreamingText(_responseText, IndexMessage) {
      if (_responseText.includes("|Text|*Streaming:true*|")) {
        _responseText = _responseText.replaceAll("|Text|*Streaming:true*|", "");


        this.listMessage[this.listMessage.length - 1].messageBot = _responseText;


        this.messageRes[IndexMessage] = "";
        this.Count_messageRes[IndexMessage] = 0;
        this.StatusPro = false;
      }
      else if (_responseText.includes("|Text|*Streaming:false*|")) {

        _responseText = _responseText.replaceAll("|Text|*Streaming:false*|", "");

        this.listMessage[this.listMessage.length - 1].messageBot = _responseText;

        this.messageRes[IndexMessage] = "";
        this.Count_messageRes[IndexMessage] = 0;
        this.StatusPro = false;
      }
      else {


        this.messageRes[IndexMessage] = _responseText;

        this.StatusPro = true;
      }
    },

    SendOpenAi_FinalizeEndedBeforeSend() {
      if (this.listMessage.length > 0 && this.messageRes.length > 0 &&
        this.listMessage[this.listMessage.length - 1].status_Process == 'END'
        && this.listMessage[this.listMessage.length - 1].messageBot != null) {
        if (this.listMessage[this.listMessage.length - 1].messageBot.length < this.messageRes[this.messageRes.length - 1].length) {
          this.Count_messageRes[this.listMessage.length - 1] = 0;
          this.StatusPro = true;
          this.listMessage[this.listMessage.length - 1].messageBot = this.messageRes[this.messageRes.length - 1];

          this.messageRes[this.messageRes.length - 1] = "";

          setTimeout(() => {
            this.CountScroll = this.MaxCountScroll;
            this.ChatRef_ScrollIntoView();
          }, 5);

          if (this.messageData == "") {
            return true;
          }
        }
      }
      return false;
    },

    SendOpenAi_ShouldAbortEarly() {
      if (!this.uploadFileComplete && this.pickedFileType != null)
        return true;

      this.GetDateTime()

      if (this.SendOpenAi_FinalizeEndedBeforeSend()) {
        return true;
      }


      if ((this.messageData == "" && this.fileDataUrl == null)) {
        return true;
      }
      if ((this.listMessage.length > 0 && (this.listMessage[this.listMessage.length - 1].status_Process != 'END'
        && this.listMessage[this.listMessage.length - 1].status_Process != 'Error'
        && this.listMessage[this.listMessage.length - 1].status_Process != 'Stop'))
        && !this.IsChainMassage) {
        return true;
      }
      return false;
    },

    SendOpenAi_PushUserMessage() {
      let _messageData = this.messageData;
      let _messageImage = "";
      let _messagePickedFile = "";
      this.messageData = "";
      let IndexMessageOld = this.listMessage.length - 1;
      if (this.ImageURL != "" && this.ImageURL != null) {
        _messageImage = `![image](${this.ImageURL})\n`;
      }
      if (this.pickedFileType != null && this.uploadFileComplete) {
        _messagePickedFile = `<img src="${this.GetFileTypeImg(this.requestVector.doctype)}" width="16" height="16" style="vertical-align: middle;"> <small>${this.pickedFileName}</small>\n`;
      }
      if (this.listMessage[IndexMessageOld] != undefined && this.IsChainMassage) {
        if (this.listMessage[IndexMessageOld].status_Process != "END") {
          this.StopMessageByIndex(IndexMessageOld);
          this.StopForChain = true;
        }
      }
      this.listMessage.push({
        messageUser: _messagePickedFile + _messageImage + _messageData,
        messageBot: '',
        status_Process: 'Process',
        requestTime: this.today,
        responseTime: null,
      });
      let IndexMessage = this.listMessage.length - 1;

      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);


      if (this.KeyTopic == null || this.KeyTopic == "" || this.Log_History_TopicID == -1) {
        this.KeyTopic = this.GetUuidv4_Fun();

      }


      if (this.listTopic.length > 0 && this.listTopic[0].topicID == -1) {
        this.listTopic[0].topicName = _messageData;

        this.listTopic[0].keyTopic = this.KeyTopic;
      }

      return { _messageData, _messagePickedFile, IndexMessage };
    },

    SendOpenAi_OnUploadProgress(IndexMessage) {


      this.Text_Run(IndexMessage);

      if (this.listMessage[IndexMessage].messageBot == "") {
        try {
          // no action required


        } catch {
        }
      }
    },

    SendOpenAi_OnDownloadProgress(progressEvent, IndexMessage) {
      // axios throttle progress (~3 ครั้ง/วิ) จึงมี event ค้างมาถึงหลังผู้ใช้กดหยุด (abort) ได้
      // ถ้าปล่อยผ่านจะเขียนสถานะกลับเป็น Send_Message + StatusPro = true ค้าง ปุ่มหยุดไม่หาย ส่งข้อความต่อไม่ได้
      if (this.Axios_Controller[IndexMessage]?.signal.aborted || this.listMessage[IndexMessage]?.status_Process == "Stop") {
        return;
      }
      // const xhr = progressEvent.event.target
      const xhr = (progressEvent.target == undefined ? progressEvent.event.target : progressEvent.target);
      // response ที่เป็น error (เช่น 400 ข้อความยาวเกิน) ไม่ใช่สตรีมคำตอบ ห้ามเอา body มาเรนเดอร์ลงฟองแชท
      if (xhr && xhr.status >= 400) {
        return;
      }
      try {

        if (this.listMessage[IndexMessage].messageBot == "" || this.listMessage[IndexMessage].messageBot == '<span class="blinking-cursor" style="">|</span>') {
          try {




            this.GetTopicStream("Steam");
          } catch {


            this.SendOpenAi_ResetDataLog();
          }
        }

        this.GetDateTime()
        const { responseText } = xhr
        console.log("=====responseText======");
        console.log(responseText);
        console.log("=====responseText.trim()======");
        console.log("[" + responseText.trim() + "]");

        let _responseText = responseText.replaceAll("data: [DONE]", "");

        // Handle bot disabled case - remove message and don't process further
        if (_responseText.trim() === "bot disabled" || _responseText.includes("bot disabled")) {
          console.log("Bot disabled detected, removing message");
          if (this.listMessage[IndexMessage]) {
            this.listMessage.splice(IndexMessage, 1);
          }
          this.messageRes[IndexMessage] = "";
          this.Count_messageRes[IndexMessage] = 0;
          this.StatusPro = false;
          return;
        }

        this.listMessage[IndexMessage].status_Process = "Send_Message";
        this.listMessage[IndexMessage].responseTime = this.today;

        if (_responseText.includes("|Products|[")) {
          const tempJson = _responseText.split("|Products|");
          _responseText = tempJson[0];
          this.products = JSON.parse(tempJson[1]);
        }


        _responseText = this.SendOpenAi_ApplyResponseMarkers(_responseText);

        _responseText = this.SendOpenAi_FinalizeResponseText(_responseText);


        // console.log("`_responseText`")
        // console.log(_responseText)







        this.SendOpenAi_ApplyStreamingText(_responseText, IndexMessage);

      } catch (e) { //NOSONAR



        this.SendOpenAi_ResetDataLog();
        console.log("e")
      }

    },

    SendOpenAi(K_in) {
      if (this.SendOpenAi_ShouldAbortEarlyForQueue()) {
        return;
      }

      if (this.messageQueue.length >= this.maxQueueSize) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('queueFull') || `Queue is full (max ${this.maxQueueSize}). Please wait for current messages to complete.`,
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      const queueItem = {
        id: Date.now() + Math.random(),
        text: this.messageData,
        fileDataUrl: this.fileDataUrl,
        pickedFileType: this.pickedFileType,
        pickedFileName: this.pickedFileName,
        ImageURL: this.ImageURL,
        uploadFileComplete: this.uploadFileComplete,
        requestVector: this.requestVector ? { ...this.requestVector } : null,
        timestamp: new Date().toISOString()
      };

      this.messageQueue.push(queueItem);
      this.messageData = "";
      this.fileDataUrl = null;
      this.pickedFileType = null;
      this.pickedFileName = null;
      this.ImageURL = "";
      this.uploadFileComplete = true;
      this.requestVector = null;

      if (!this.isProcessing) {
        this.processQueue();
      }
    },

    SendOpenAi_ShouldAbortEarlyForQueue() {
      if (!this.uploadFileComplete && this.pickedFileType != null)
        return true;

      this.GetDateTime()

      if (this.SendOpenAi_FinalizeEndedBeforeSend()) {
        return true;
      }

      if ((this.messageData == "" && this.fileDataUrl == null)) {
        return true;
      }
      return false;
    },

    async processQueue() {
      if (this.isProcessing || this.messageQueue.length === 0) {
        return;
      }

      this.isProcessing = true;
      const item = this.messageQueue.shift();

      this.messageData = item.text;
      this.fileDataUrl = item.fileDataUrl || null;
      this.pickedFileType = item.pickedFileType || null;
      this.pickedFileName = item.pickedFileName || null;
      this.ImageURL = item.ImageURL || "";
      this.uploadFileComplete = item.uploadFileComplete !== undefined ? item.uploadFileComplete : true;
      this.requestVector = item.requestVector || null;

      // Fire and forget - callbacks will call processQueue() when done
      this.sendCore(item.id);
    },

    async sendCore(queueId) {
      let { _messageData, _messagePickedFile, IndexMessage } = this.SendOpenAi_PushUserMessage();



      let dataPost = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": this.SessionID,
            "source": this.BuildStreamSource(),
            "message": {
              "id": "325708",
              "type": "text",
              // "text": DataSend
              // "text": "ประวัติประเทศไทย"
              "ImageURL": this.ImageURL == "" || this.IsAllowImage == false ? null : this.ImageURL, //NOSONAR
              "topicModelID": this.TopicModelID_long,
              "topicID": this.Log_History_TopicID,
              "keyTopic": this.KeyTopic,
              "reasoning_effort": this.GetAppliedReasoningEffort(),


              "text": (this.pickedFileType == null ? "" : _messagePickedFile) + _messageData
            },
            "PersonalInfoToken": this.personalInfoToken
            // ,"stream": true
          }
        ]
      };
      this.Stop_Flag = false;
      this.messageRes[IndexMessage] = "";
      this.Count_messageRes[IndexMessage] = 0;
      this.StatusPro = true;
      this.ClearImage();
      this.ClearUploadedFile();

      this.Axios_Controller[IndexMessage] = new AbortController();

      let Config = {
        signal: this.Axios_Controller[IndexMessage].signal,
        onUploadProgress: () => {
          this.SendOpenAi_OnUploadProgress(IndexMessage);
        },
        onDownloadProgress: progressEvent => {
          this.SendOpenAi_OnDownloadProgress(progressEvent, IndexMessage);
        }
      }

      try {
        this.$call.GptStreamPOST(dataPost, Config, () => {
          if (this.listMessage[IndexMessage].messageBot == "**#Personal Information**") //this.personalInfoToken
          {
            this.SendOpenAi_HandlePersonalInfo(Config, _messageData, _messagePickedFile, IndexMessage);
          }
          else {
            this.SendOpenAi_HandleSuccess(_messageData, IndexMessage);
          }
        },
          (_response) => {
            this.SendOpenAi_HandleError(_response, IndexMessage);


          }
        );
      }
      catch {
        console.log("E : atch ");
      }


    },


    SendOpenAi_HandleSuccess(_messageData, IndexMessage) {
      // Handle bot disabled case - remove message and don't show anything
      if (this.listMessage[IndexMessage] &&
        (this.listMessage[IndexMessage].messageBot.trim() === "bot disabled" ||
          this.listMessage[IndexMessage].messageBot.trim() === "" ||
          this.messageRes[IndexMessage]?.includes("bot disabled"))) {
        this.listMessage.splice(IndexMessage, 1);
        this.messageRes[IndexMessage] = "";
        this.Count_messageRes[IndexMessage] = 0;
        this.StatusPro = false;
        return;
      }

      if (_messageData.trim() == ":clearhistory") {
        this.listMessage = [];
        this.messageData = "";
        if (this.messageRes.length > 0) {
          this.messageRes[this.messageRes.length - 1] = "";
        } else {
          this.messageRes[0] = "";
        }
        this.Count_messageRes[this.listMessage.length - 1] = 0;
        this.StatusPro = false;
        return;
      }
      this.StatusPro = false;
      this.StopForChain = false;
      this.successalert = true;
      this.listMessage[IndexMessage].status_Process = "END";
      this.GetLogStream(_messageData);
      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
      // Process next queued message
      this.isProcessing = false;
      this.$nextTick(() => this.processQueue());
    },


    SendOpenAi_HandleError(_response, IndexMessage) {
      console.log("catch");
      // ผู้ใช้กดหยุดเอง (abort) ไม่ใช่ error — StopMessage ตั้งข้อความ/สถานะไว้แล้ว
      // ห้ามตั้ง StatusPro = StopForChain หรือต่อข้อความ error ทับ เหลือแค่ปล่อยคิว
      if (this.listMessage[IndexMessage]?.status_Process == "Stop") {
        this.isProcessing = false;
        this.$nextTick(() => this.processQueue());
        return;
      }
      this.erroralert = true;

      // backend ปฏิเสธเพราะข้อความยาวเกินเพดานของโมเดล ไม่ใช่ error ทั่วไป
      const isTooLong = isInputTooLongError(_response);
      const serverLimit = isTooLong ? parseServerCharLimit(_response, this.maximumChatInput) : this.maximumChatInput;
      if (isTooLong) {
        this.maximumChatInput = serverLimit; // sync เพดานจริงจาก backend ครั้งต่อไปบล็อกได้ตั้งแต่ในเบราว์เซอร์
      }
      const errorText = isTooLong
        ? this.$t('_chatMessageTooLong', { max: serverLimit })
        : "Error something went wrong ...";

      if (this.listMessage.length == 0) {
        // no action required
      }
      else {
        this.StatusPro = this.StopForChain;

        this.Count_messageRes[IndexMessage] = 0;

        this.messageData = "";
        console.log(this.listMessage[IndexMessage]);
        if (isTooLong && this.listMessage[IndexMessage].status_Process != "Stop") {
          // body ที่ progress handler เขียนไว้เป็นรหัส INPUT_TOO_LONG ดิบ ต้องทับทั้งก้อน ห้ามต่อท้าย
          this.listMessage[IndexMessage].messageBot = errorText;
        }
        else if (this.listMessage.length > 0 && this.listMessage[IndexMessage].messageBot.length < this.messageRes[IndexMessage].length && !this.StopForChain) {
          this.listMessage[IndexMessage].messageBot = (this.messageRes[IndexMessage] + "<br />" + errorText);
        }
        else if (!this.StopForChain && this.listMessage[IndexMessage].status_Process != "Stop") {
          this.listMessage[IndexMessage].messageBot += errorText;
        }
        this.messageRes[IndexMessage] = "";
        if (this.listMessage[IndexMessage].status_Process != "Stop") {
          this.listMessage[IndexMessage].status_Process = this.StopForChain ? "ChatChain" : "Error";
        }
      }
      this.Stop_Flag = false;
      console.log("Error : " + _response);

      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
      // Process next queued message
      this.isProcessing = false;
      this.$nextTick(() => this.processQueue());
    },


    SendOpenAi_HandlePersonalInfo(Config, _messageData, _messagePickedFile, IndexMessage) {
      this.listMessage[IndexMessage].status_Process = "Process";
      //#region Personal Information
      window.open(`${API_BASE_URL}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

      const handleMessage = async (event) => {
        try {
          // ตรวจสอบข้อมูลจาก popup
          if (!event.data || !event.data.message) return;

          const data = event.data;
          this.personalInfoToken = data.message;

          let dataPost = {
            "events": [
              {
                "replyToken": "dummyToken",
                "type": "message",
                "timestamp": 1462629479859,
                "fullStream": false,
                "stream": true,
                "SessionID": this.SessionID,
                "source": this.BuildStreamSource(),
                "message": {
                  "id": "325708",
                  "type": "text",
                  "ImageURL": this.ImageURL == "" || this.IsAllowImage == false ? null : this.ImageURL, //NOSONAR
                  "topicModelID": this.TopicModelID_long,
                  "topicID": this.Log_History_TopicID,
                  "keyTopic": this.KeyTopic,
                  "reasoning_effort": this.GetAppliedReasoningEffort(),


                  "text": (this.pickedFileType == null ? "" : _messagePickedFile) + _messageData
                },
                "PersonalInfoToken": this.personalInfoToken
              }
            ]
          };

          this.$call.GptStreamPOST(dataPost, Config, () => {
            // ทำงานเมื่อสำเร็จ (response จาก GPT)
            this.StatusPro = false;
            this.StopForChain = false;
            this.successalert = true;
            let msgRes = this.messageRes.filter(e => e != null && e != undefined && e != '');
            if (msgRes.length > 0 && this.listMessage[IndexMessage] != undefined) {
              this.listMessage[IndexMessage].messageBot = msgRes[Math.min(IndexMessage, msgRes.length - 1)];
            }
            this.listMessage[IndexMessage].status_Process = "END";
            this.GetLogStream(_messageData);
            setTimeout(() => {
              this.CountScroll = this.MaxCountScroll;
              this.ChatRef_ScrollIntoView();
            }, 5);
            // Process next queued message
            this.isProcessing = false;
            this.$nextTick(() => this.processQueue());
          },
            (_response) => {
              // กรณีเกิด error ใน GptStreamPOST
              this.erroralert = true;

              // backend ปฏิเสธเพราะข้อความยาวเกินเพดานของโมเดล ไม่ใช่ error ทั่วไป
              const isTooLong = isInputTooLongError(_response);
              const serverLimit = isTooLong ? parseServerCharLimit(_response, this.maximumChatInput) : this.maximumChatInput;
              if (isTooLong) {
                this.maximumChatInput = serverLimit; // sync เพดานจริงจาก backend
              }
              const errorText = isTooLong
                ? this.$t('_chatMessageTooLong', { max: serverLimit })
                : "Error something went wrong ...";

              if (this.listMessage.length == 0) {
                // no action required
              }
              else {
                this.StatusPro = this.StopForChain;

                this.Count_messageRes[IndexMessage] = 0;
                this.messageData = "";
                if (isTooLong && this.listMessage[IndexMessage].status_Process != "Stop") {
                  // body ที่ progress handler เขียนไว้เป็นรหัส INPUT_TOO_LONG ดิบ ต้องทับทั้งก้อน ห้ามต่อท้าย
                  this.listMessage[IndexMessage].messageBot = errorText;
                }
                else if (this.listMessage.length > 0 && this.listMessage[IndexMessage].messageBot.length < this.messageRes[IndexMessage].length && !this.StopForChain) {
                  this.listMessage[IndexMessage].messageBot = (this.messageRes[IndexMessage] + "<br />" + errorText);
                }
                else if (!this.StopForChain && this.listMessage[IndexMessage].status_Process != "Stop") {
                  this.listMessage[IndexMessage].messageBot += errorText;
                }
                this.messageRes[IndexMessage] = "";
                if (this.listMessage[IndexMessage].status_Process != "Stop") {
                  this.listMessage[IndexMessage].status_Process = this.StopForChain ? "ChatChain" : "Error";
                }
              }

              this.Stop_Flag = false;

              setTimeout(() => {
                this.CountScroll = this.MaxCountScroll;
                this.ChatRef_ScrollIntoView();
              }, 5);
              // Process next queued message
              this.isProcessing = false;
              this.$nextTick(() => this.processQueue());
            }
          );

        } catch (error) {
          console.log("🐞 ใน handleMessage:", error);
        } finally {
          console.log("🛑 EventListener message");
          window.removeEventListener('message', handleMessage);
        }
      };

      console.log("🧱 EventListener message");
      window.addEventListener('message', handleMessage);
      // #endregion Personal Information
    },


    Text_Run(IndexMessage) {

      setTimeout(() => {

        if (this.messageRes[IndexMessage] == undefined) {
          return;
        }
        // ผู้ใช้กดหยุดแล้ว ห้ามพิมพ์ต่อจาก buffer
        if (this.listMessage[IndexMessage]?.status_Process == "Stop") {
          return;
        }
        if ((this.Count_messageRes[IndexMessage] >= this.messageRes[IndexMessage].length && !this.StatusPro) || this.listMessage[IndexMessage].status_Process == "ChatChain") {
          setTimeout(() => {
            this.CountScroll = this.MaxCountScroll;
            this.ChatRef_ScrollIntoView();
          }, 5);
        }
        if ((this.Count_messageRes[IndexMessage] < this.messageRes[IndexMessage].length || this.StatusPro) && this.listMessage[IndexMessage].status_Process != "ChatChain") {


          this.Text_Run_StripCursor(IndexMessage);


          if (this.Count_messageRes[IndexMessage] < this.messageRes[IndexMessage].length) {
            this.Text_Run_AppendChar(IndexMessage);

            this.Count_messageRes[IndexMessage]++;
            this.ChatRef_ScrollIntoView();
          }



          this.listMessage[IndexMessage].messageBot += ``;


          this.Text_Run_Finalize(IndexMessage);


          this.Text_Run(IndexMessage);
        }

      }, this.Time_Delay);

    },


    Text_Run_StripCursor(IndexMessage) {
      if (this.listMessage[IndexMessage].messageBot.length > 0 && this.listMessage[IndexMessage].messageBot.substring(this.listMessage[IndexMessage].messageBot.length - 47, this.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {

        this.listMessage[IndexMessage].messageBot = this.listMessage[IndexMessage].messageBot.substring(0, this.listMessage[IndexMessage].messageBot.length - 47);
      }
    },


    Text_Run_AppendChar(IndexMessage) {

      if (this.messageRes[IndexMessage].length > (this.Count_messageRes[IndexMessage] + 5) && this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage]] == "<") {
        this.Text_Run_AppendTag(IndexMessage);
      }
      else if ((this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage]] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 1] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 2]
        + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 3] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 4] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 5]
        + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 6] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 7] == "![Image]") || this.messageImage != "") {
        this.Text_Run_AppendImage(IndexMessage);
      }
      else {
        this.listMessage[IndexMessage].messageBot += this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage]];
        this.messageImage = "";
      }
    },


    Text_Run_AppendTag(IndexMessage) {
      if (this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage]] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 1] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 2]
        + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 3] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 4] + this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + 5]
        == "<br />") {

        this.listMessage[IndexMessage].messageBot += "<br />";
        this.Count_messageRes[IndexMessage] += 5;
      }
      else if (this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage]] == "<") {

        this.listMessage[IndexMessage].messageBot += this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage]];
      }
      else {
        this.listMessage[IndexMessage].messageBot += this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage]];
      }
    },


    Text_Run_AppendImage(IndexMessage) {
      let count = 0;
      for (let index = this.Count_messageRes[IndexMessage]; index < this.messageRes[IndexMessage].length; index++) {
        const element = this.messageRes[IndexMessage][index];
        this.messageImage += element;
        count++;
        if (element == ")") {
          break;
        }
      }
      if (this.messageRes[IndexMessage][this.Count_messageRes[IndexMessage] + (count - 1)] == ")") {
        this.listMessage[IndexMessage].messageBot += this.messageImage
        this.messageImage = "";
      }
      this.Count_messageRes[IndexMessage] += count - 1;
    },


    Text_Run_Finalize(IndexMessage) {
      if (this.Count_messageRes[IndexMessage] == this.messageRes[IndexMessage].length && this.listMessage[IndexMessage].status_Process == "END") {


        if (this.listMessage[IndexMessage].messageBot.length > 0 && this.listMessage[IndexMessage].messageBot.substring(this.listMessage[IndexMessage].messageBot.length - 47, this.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {

          this.listMessage[IndexMessage].messageBot = this.listMessage[IndexMessage].messageBot.substring(0, this.listMessage[IndexMessage].messageBot.length - 47);
        }
        this.listMessage[IndexMessage].messageBot = this.listMessage[IndexMessage].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
      }
    },


    Replace_NewLine(input) {
      return replaceLeadingNewlines(input);
    },
    GetLogStream_ParseReplyMsg(DataLog_Data) {
      let replymsg = null;
      try {

        this.Log_History_TopicID = DataLog_Data.topicID;
        replymsg = JSON.parse(DataLog_Data.replymsg);


        replymsg.Vector = this.Replace_NewLine(replymsg.Vector);
        replymsg.VectorCoise = this.Replace_NewLine(replymsg.VectorCoise);
        replymsg.Private_Memory = this.Replace_NewLine(replymsg.Private_Memory);


        if (replymsg == null) {
          replymsg = this.GetLogStream_EmptyReplyMsg();
        }
      }
      catch {
        replymsg = this.GetLogStream_EmptyReplyMsg();
      }
      return replymsg;
    },

    GetLogStream_EmptyReplyMsg() {
      return {
        Vector: "",
        VectorCoise: "",
        Private_Memory: "",
        AiAttempts: [],
        GPT_Model: {
          ModelID: "",
          ModelName: "",
          Provider: "",
          Model: "",
          Extension: "",
          Description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          TopVDB: "",
          internet: "",
          feedback: "",
          HistoryCount: "",
          HistoryMinute: "",
          temperature: "",
          top_p: "",
          frequency_penalty: "",
          presence_penalty: "",
          Stop: "",
          max_tokens: "",
          IsStream: ""
        }
      };
    },

    GetLogStream_BuildMemory(DataLog_Data) {
      return buildShortMemoryText(DataLog_Data);
    },

    GetLogStream_BuildSuccessDataLog(replymsg, Memory, DataLog_Data) {
      return {
        Prompt: replymsg.GPT_Model.promptTemplate,
        Vector: replymsg.Vector,
        ReplySQL: replymsg.ReplySQL,
        ReplyDataSelect: replymsg.ReplyDataSelect,
        Memory: Memory,
        Translate: replymsg.Translate,
        FlowActionIntent: replymsg.FlowActionIntent,
        GPT_Model: {
          ModelID: replymsg.GPT_Model.ModelID,
          ModelName: replymsg.GPT_Model.ModelName,
          Provider: replymsg.GPT_Model.Provider,
          Model: replymsg.GPT_Model.Model,
          Extension: replymsg.GPT_Model.Extension,
          Description: replymsg.GPT_Model.Description,
          promptTemplate: replymsg.GPT_Model.promptTemplate,
          gender: replymsg.GPT_Model.gender,
          vectordbName: replymsg.GPT_Model.vectordbName,
          TopVDB: replymsg.GPT_Model.TopVDB,
          internet: replymsg.GPT_Model.internet,
          feedback: replymsg.GPT_Model.feedback,
          HistoryCount: replymsg.GPT_Model.HistoryCount,
          HistoryMinute: replymsg.GPT_Model.HistoryMinute,
          temperature: replymsg.GPT_Model.temperature,
          top_p: replymsg.GPT_Model.top_p,
          frequency_penalty: replymsg.GPT_Model.frequency_penalty,
          presence_penalty: replymsg.GPT_Model.presence_penalty,
          Stop: replymsg.GPT_Model.Stop,
          max_tokens: replymsg.GPT_Model.max_tokens,
          IsStream: replymsg.GPT_Model.IsStream,
          EndpointURL: replymsg.GPT_Model.EndpointURL
        },
        Text: DataLog_Data.text,
        TextVector: replymsg.GPT_Model.TextVector,
        VectorCoise: replymsg.VectorCoise,
        Private_Memory: replymsg.Private_Memory,
        AiAttempts: replymsg.AiAttempts || []

      };
    },

    GetLogStream_EmptyDataLog() {
      return {
        Prompt: "",
        Vector: "",
        ReplySQL: "",
        ReplyDataSelect: "",
        Memory: "",
        Translate: "",
        FlowActionIntent: "",
        GPT_Model: {
          ModelID: "",
          ModelName: "",
          Provider: "",
          Model: "",
          Extension: "",
          Description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          TopVDB: "",
          internet: "",
          feedback: "",
          HistoryCount: "",
          HistoryMinute: "",
          temperature: "",
          top_p: "",
          frequency_penalty: "",
          presence_penalty: "",
          Stop: "",
          max_tokens: "",
          IsStream: "",
          EndpointURL: ""
        },
        Text: "",
        TextVector: "",
        VectorCoise: "",
        Private_Memory: "",
        AiAttempts: []
      };
    },

    GetLogStream(_messageData) {

      this.DataLog = this.GetLogStream_EmptyDataLog();

      try {
        let _User_Id = { UserChannel: this.User_Id, TopicID: this.Log_History_TopicID };

        this.$call.GetLogMonitor(_User_Id, (response) => {

          try {

            if (response.status == 0 && response.data.status == true) { //NOSONAR
              let DataLog_Data = response.data.data;
              this.DataLog_Data = DataLog_Data;

              let replymsg = this.GetLogStream_ParseReplyMsg(DataLog_Data);

              let Memory = this.GetLogStream_BuildMemory(DataLog_Data);

              this.DataLog = this.GetLogStream_BuildSuccessDataLog(replymsg, Memory, DataLog_Data);



            }
            else {
              this.DataLog = this.GetLogStream_EmptyDataLog();
            }
          }
          catch {
            this.DataLog = this.GetLogStream_EmptyDataLog();
          }
        }, () => {
          this.DataLog = this.GetLogStream_EmptyDataLog();

          console.log('GetLogStream : false')
        });
      }
      catch {

        this.Status_Error = true;
        this.Text_Status = "ไม่พบ Auth";

      }


    },
    GetToken() {


      return new Promise((resolve) => {

        try {
          this.streamAuthToken = "";
          this.auth_token = "";
          this.$call.GetTokenFullStream({}, (response) => {
            if (response.status == 0 && response.data.status) {
              const token = response.data.data;
              this.streamAuthToken = token;
              this.auth_token = token;
              this.Time_Delay = response.data.timeDelay;
              this.maximumChatInput = 200000;
              this.GetLogStreamStart_Flag = true;
              this.GetTopicStream("Start");
              this.GetModelFirst_Value(null);
              resolve(true);
            }
            else {
              this.streamAuthToken = "";
              this.auth_token = "";
              resolve(false);
            }
          },
            () => {
              this.streamAuthToken = "";
              this.auth_token = "";
              resolve(false);
            }
          );
        }
        catch {

          this.streamAuthToken = "";
          this.auth_token = "";
          resolve(false);

        }
      });

    },

    GetHistoryStream(Status) {

      if (this.Loading_History_Status) {
        return;
      }
      try {


        let _User_Id = {
          TopicID: this.Log_History_TopicID,
          USER_CHANNEL: this.User_Id,
          ID: this.Log_History_ID,
          Take: this.Log_History_Take
        };

        this.Loading_History_Status = true;
        this.$call.GetHistoryStream(_User_Id, (response) => {

          if (response.status == 0) {

            let response_data = response.data

            if (Status == "Start") {
              this.listMessage = response_data;
              this.SetButtom_Page();
            }
            else if (Status == "ScrollUp") {

              if ((this.listMessage.length > 0 && this.listMessage[0].id == undefined)) {
                this.flagTopHistory = false;
              } else {

                this.listMessage = response_data.concat(this.listMessage);
              }

              if (flagTopHistory) {
                setTimeout(() => {
                  const element1 = document.getElementById("ChatId_" + this.Log_History_ID);
                  if (element1 != undefined && element1 != null) {
                    this.$refs.ChatScreRef.scrollTop = element1.offsetTop - 20;
                  }
                  this.Loading_History_Status = false;
                }, 1);
              }
            }
          }
          else {
            // no action required
          }


          // setTimeout(() => {
          this.Loading_History_Status = false;
          // }, 1000);

        },
          () => {

            // setTimeout(() => {
            this.Loading_History_Status = false;
            // }, 1000);

            console.log('GetHistoryStream : false')
          }
        );
      }
      catch {
        // no action required
      }


    },


    GetTopicStream_ApplyTopicConfig(response_data) {
      if (this.Log_History_TopicID == -1) {
        this.Time_Delay = response_data[0].timeDelay;
        this.maximumChatInput = response_data[0].maximumChatInput || 200000;
        this.IsAllowImage = response_data[0].isAllowImage;
        this.FileUploadLimit = response_data[0].fileUploadLimit;
        this.IsChainMassage = response_data[0].isChainMassage;
      }
      else {
        const topic = response_data.find(e => e.topicID == this.Log_History_TopicID);
        this.Time_Delay = topic.timeDelay;
        this.maximumChatInput = topic.maximumChatInput || 200000;
        this.IsAllowImage = topic.isAllowImage;
        this.FileUploadLimit = topic.fileUploadLimit;
        this.IsChainMassage = topic.isChainMassage;
      }
    },

    GetTopicStream_ApplyTopicSelection(response_data) {
      this.Log_History_TopicID = response_data[0].topicID;
      this.TopicName = response_data[0].topicName;
      this.TopicModelID = response_data[0].topicModelID;
      this.KeyTopic = response_data[0].keyTopic;

      if (response_data[0].topicModelID_long != null) {
        this.TopicModelID_long = response_data[0].topicModelID_long;
      }

      this.ModelFirst = response_data[0].topicModelID;
    },

    GetTopicStream_MaybeApplyTopicConfig(response_data) {
      if (this.listMessage.length > 0) {
        if (([':model'].some(keyword => this.listMessage[this.listMessage.length - 1].messageUser.toLowerCase().includes(keyword.toLowerCase())))) {
          this.GetTopicStream_ApplyTopicConfig(response_data);
        }
      } else if (response_data.length > 0) {
        this.GetTopicStream_ApplyTopicConfig(response_data);
      }
    },

    GetTopicStream_HandleStartStatus(response_data) {
      if (response_data.length > 0) {
        this.GetTopicStream_ApplyTopicSelection(response_data);

        if (this.GetLogStreamStart_Flag) {
          this.GetLogStreamStart_Flag = false;
          this.GetLogStream("");
        }
        this.Topic_STATUS = true;

      } else {
        this.GetModelFirst(null);
      }
    },

    GetTopicStream_HandleSteamStatus(response_data) {
      if (response_data.length > 0) {
        this.GetTopicStream_ApplyTopicSelection(response_data);
      }
      else {
        this.GetModelFirst(null);
      }
    },

    GetTopicStream_HandleSuccess(response_data, status) {
      this.flagTopHistory = true;

      this.listTopic = response_data;
      this.GetTopicStream_MaybeApplyTopicConfig(response_data);

      if (status == "Steam") {
        this.GetTopicStream_HandleSteamStatus(response_data);
      }
      else {
        console.log("GetTopicStream : true")
        if (status == "Start") {
          this.GetTopicStream_HandleStartStatus(response_data);
        }


        this.GetHistoryStream("Start");
      }
    },

    GetTopicStream(status) {

      try {


        let _User_Id = {
          USER_CHANNEL: this.User_Id
        };

        this.$call.GetTopicStreamToken(_User_Id, this.getCurrentStreamToken(), (response) => {

          if (response.status == 0 && _User_Id.USER_CHANNEL == this.User_Id) {

            let response_data = response.data
            this.GetTopicStream_HandleSuccess(response_data, status);
          }
          else {
            this.listTopic = [];

            this.GetModelFirst(null);
          }



        },
          () => {

            this.listTopic = [];

            this.GetModelFirst(null);
            console.log('GetTopicStream : false')
          }
        );
      }
      catch {

        this.GetModelFirst(null);
        this.listTopic = [];

      }
    },
    ChatScreScroll(e) {

      if (this.$refs.ChatScreRef.scrollTop <= this.LastScrollTop &&
        this.$refs.ChatScreRef.scrollTop == 0 && !this.Loading_History_Status &&
        this.flagTopHistory) {


        if (this.listMessage.length > 0) {


          this.Log_History_ID = this.listMessage[0].id;



          this.GetHistoryStream("ScrollUp");


        }
      }
      else {
        // no action required
      }


      this.LastScrollTop = this.$refs.ChatScreRef.scrollTop;


    },

    SetButtom_Page() {
      setTimeout(() => {
        if (this.$refs.ChatRef) {
          this.$refs.ChatScreRef.scrollTop = this.$refs.ChatRef.offsetTop;
        }
        else {
          this.SetButtom_Page();
        }


      }, 100);
    },
    GetDateTime() {
      let month_names_short = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth(); //January is 0!

      let hh = today1.getHours();
      let m = today1.getMinutes();

      if (dd < 10) {
        dd = '0' + dd;
      }
      if (m < 10) {
        m = '0' + m;
      }

      this.today = dd + ' ' + month_names_short[mm] + " " + hh + ":" + m;
    },

  },
  mounted() {
    this.loadWaveSurferCDN().catch((error) => {
      console.warn('WaveSurfer record plugin preload failed:', error);
    });
    this.AutoRefresh();
    this.GetDDGroupReplaceDB_Stream();
    this.GetDDGPTModelList();

    this.SessionID = this.GetUuidv4_Fun();
    this.$nextTick(() => {
      this.GetUuidv4();
      this.GetToken();
      this.Themecolor();

      this.Log_History_Take = 5;
      this.Log_History_ID = null;
      this.KeyTopic = null;
      this.TopicModelID_long = -1;
      this.StatusKeyRename = false;
      this.ModelFirst = "-";



      this.TopicName = "";
      this.TopicModelID = "";
      this.Log_History_TopicID = -1;



    })
    if (this.$route.query.name) {
      this.requestVector.searchVectorDBName2 = this.$route.query.name;
      this.showTable = true;
      this.actionEdit = true;
      this.flagNew = false;
    } else {
      this.dataUpdate = 0;
      this.GetMaxLimitedCharacter();
    }
    if (this.requestVector.MaxLimitedCharacter == null) {
      this.ReFresh();
    }


  },

};
</script>
<style scoped>
:deep(i.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-icon--clickable.v-autocomplete__menu-icon) {
  color: #872612 !important;
  opacity: 1 !important;
}

.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.card1 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  margin-top: 1rem;
  padding: 1rem;
}

.card {
  border-radius: 16px !important;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
  padding-top: 0.5em;
}
</style>
<style>
.Log_text_textarea .v-text-field__slot {
  margin-right: -11px !important;

}

.Log_text_textarea textarea {
  color: black !important;
  background-color: #ffffff !important;
}

.rounded-circle {
  border-radius: 50%;
  width: 35px;
  height: 35px;
}

.image-container {
  transition: .5s ease;
  position: absolute;
  top: 40%;
  right: 0.55%;
  width: 35px;
  height: 35px;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 48%;
  left: 48%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.middle-progress {
  transition: .5s ease;
  position: absolute;
  top: 0%;
  left: 0%;
  color: rgb(247, 179, 78) !important;
  height: 35px !important;
  width: 35px !important;
}

.image-container:hover .middle {
  opacity: 1;
}

.delete-btn {
  background-color: rgba(151, 109, 48, 0.5) !important;
  color: white;
  font-size: 16px;
  height: 35px !important;
  width: 35px !important;
}

.responsive-table td {
  white-space: nowrap;
  /* Prevent line breaks within cells */
  overflow: hidden;
  /* Hide overflowed content */
  text-overflow: ellipsis;
  /* Show ellipsis for overflowed content */
  overflow-wrap: anywhere;
}

.attach-button {
  background-color: transparent !important;
  color: gray !important;
  border-radius: 15px !important;
  box-shadow: none;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /* Number of lines to show */
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;

  /* margin-right: 8px; Adjust space between text and button if needed */
}

.text-content-show {
  overflow: hidden;
  /*-webkit-line-clamp: 2; /* Number of lines to show */
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

@keyframes fadeUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  to {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
}

.attachment-list-item {
  margin: 0;
  border-radius: 8px;
  margin-bottom: 2px;
  transition: all 0.15s ease;
  cursor: pointer;
  padding: 10px 12px !important;
  min-height: 44px !important;
}

.attachment-list-item:hover {
  background: #F3F4F6 !important;
}

.attachment-list-item-active {
  background-color: rgba(0, 0, 0, 0.08) !important;
}

/* Fix for the minimal fab button */
.minimal-fab {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease;
  height: 32px !important;
  width: 32px !important;
  min-width: 32px !important;
  margin-left: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  background-color: #f5f5f5 !important;
}

.minimal-fab:hover {
  transform: scale(1.05);
  background-color: #e0e0e0 !important;
}

.minimal-fab .v-icon {
  font-size: 16px;
  color: #71717A;
}

:deep(#C_V_markDown) {
  display: grid;
}

:deep(#C_V_markDown) p {
  margin: 0;
  display: block;
}

:deep(#C_V_markDown) table {
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: gray;
  display: table;
  text-indent: 0;
  color: #2b2b2b !important;
}

:deep(#C_V_markDown) tr {
  border-top: 1px solid #c6cbd1;
  background: #fff;
}

:deep(#C_V_markDown) td,
#C_V_markDown th {
  padding: 6px 13px;
  border: 1px solid #dfe2e5;
}

:deep(#C_V_markDown) table tr:nth-child(2n) {
  background: #d8d9da;
}

:deep(#C_V_markDown) li code,
:deep(#C_V_markDown) p code {
  background-color: transparent;
  color: blue;
}

:deep(#C_V_markDown) code.language-markdown,
:deep(#C_V_markDown) pre code {
  display: block;
  background: #2b2b2b;
  color: #f0f8ff;
  border: 6px, double, white;
}

:deep(#C_V_markDown) code {
  white-space: pre-wrap;
  background: #2b2b2b;
  color: #f0f8ff;
}

:deep(#C_V_markDown) pre code {
  margin: 10px 0px;
}

:deep(#C_V_markDown) img {
  max-width: 100%;
  max-height: 320px
}

:deep(#C_V_markDown) ul.contains-task-list li {
  margin-top: -20px
}

:deep(#C_V_markDown) br {
  content: "";
  margin: 0;
  display: block;
  font-size: 24%;
}

:deep(#C_V_markDown) li {
  margin-top: -1em;
}


:deep(#C_V_markDown) li p {

  margin-top: -22px;
}

:deep(#C_V_markDown) li p strong {
  margin-top: -22px;
  display: block;
}

:deep(#C_V_markDown) ul {
  margin-bottom: -20px;
}

:deep(#C_V_markDown) ol li ul {
  margin-bottom: -40px;
}

:deep(#C_V_markDown) h1,
#C_V_markDown h2,
#C_V_markDown h3,
#C_V_markDown h4,
#C_V_markDown h5 {
  margin-top: 7.5px;
  margin-bottom: 7.5px;
}

:deep(#C_V_markDown) ol {
  margin-bottom: -25px;
}

:deep(#C_V_markDown) blockquote {
  margin-top: -35px
}

:deep(#C_V_markDown) .container {
  margin-top: 0px;
}

.tool-btn {
  width: 30px !important;
  height: 30px !important;
}

.tool-box {
  border-radius: 12px;
  margin-top: 10px;
  border: 1px solid #E7EBFF;
  background: rgba(231, 235, 255, 0.25);
}

/* File Preview Containers */
.file-preview-container {
  position: relative;
  margin-bottom: 12px;
  border-radius: 12px;
  background: linear-gradient(145deg, #f8f9fa, #e9ecef);
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.file-preview-container:hover {
  transform: translateY(-1px);
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.15),
    0 2px 6px rgba(0, 0, 0, 0.1);
}

/* Image Preview */
.image-preview {
  width: 80px;
  height: 80px;
  overflow: hidden;
}

.preview-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.preview-close-btn {
  position: absolute;
  top: 0px;
  right: 0px;
}

/* File Attachment */
.file-attachment {
  width: 320px;
  padding: 12px;
}

.file-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.file-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(var(--v-theme-primary), 0.1);
}

.file-icon {
  width: 24px;
  height: 24px;
  transition: all 0.3s ease;
}

.file-icon.file-processing {
  filter: grayscale(100%) opacity(0.5);
}

.file-progress-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.file-details {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(var(--v-theme-on-surface), 0.87);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}

.file-progress {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-text {
  font-size: 12px;
  color: rgba(var(--v-theme-on-surface), 0.6);
  min-width: 32px;
}

.file-status {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: rgba(var(--v-theme-success), 1);
  font-weight: 500;
}

.file-close-btn {
  background: rgba(var(--v-theme-error), 0.1) !important;
}

/* Textarea Container */
.textarea-container {
  position: relative;
  display: flex;
}

.stream-textarea .v-field__input {
  padding-left: 15px;
  mask-image: none;
}

.stream-textarea .v-field__outline {
  border-radius: 16px !important;
}

.stream-textarea .v-input__details {
  display: none !important;
}

.stream-textarea :deep(.v-field) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.stream-textarea :deep(.v-field):hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.stream-textarea :deep(.v-field--focused) {
  border-radius: 25px !important;
  box-shadow: 0 4px 16px rgba(var(--v-theme-primary), 0.2);
}

/* Send Button */
.send-button-container {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 8px;
}

.send-btn {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.send-btn:not(:disabled):hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary), 0.3);
}

/* Attachment Menu */
.attachment-menu {
  display: flex;
  align-items: flex-end;
  padding-bottom: 8px;
}

.attachment-btn {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.attachment-btn:hover {
  background: rgba(var(--v-theme-on-surface), 0.08) !important;
  transform: scale(1.05);
}

.attachment-menu-card {
  border-radius: 16px !important;
  border: 1px solid var(--Field-border, #C9C9C9);
  background: var(--side-bar-bg, linear-gradient(180deg, #FFF 0%, #FFF5F2 100%)) !important;
  box-shadow: 0 -4px 22px 0 rgba(201, 201, 201, 0.25), 0 4px 22px 0 rgba(201, 201, 201, 0.25), 0 4px 10px 0 rgba(0, 0, 0, 0.10);
}

.model-menu-card {
  width: 300px !important;
  min-width: 300px !important;
  max-width: 300px !important;
  height: 392px !important;
  min-height: 392px !important;
  max-height: 392px !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.model-menu-title {
  font-size: 14px;
  font-weight: 600;
  color: #171717;
  flex: 0 0 auto;
}

.model-menu-search :deep(.v-field) {
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.96) !important;
  border: 1px solid rgba(201, 201, 201, 0.95) !important;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08) !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.model-menu-search :deep(.v-field:hover) {
  border-color: rgba(56, 89, 208, 0.25) !important;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.10) !important;
}

.model-menu-search :deep(.v-field--focused) {
  border-color: rgba(56, 89, 208, 0.65) !important;
  box-shadow: 0 0 0 3px rgba(56, 89, 208, 0.10), 0 8px 20px rgba(0, 0, 0, 0.10) !important;
}

.model-menu-search :deep(.v-field__input) {
  min-height: 42px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  color: #171717;
}

.model-menu-search :deep(.v-field__prepend-inner) {
  padding-top: 0 !important;
  align-self: center;
}

.model-menu-scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: 100%;
  overflow-y: auto;
}

.model-menu-list {
  min-width: 0 !important;
}

.model-menu-item-active {
  background: rgba(56, 89, 208, 0.08) !important;
}

.model-menu-item-title {
  max-width: 216px;
}

.model-menu-item-subtitle {
  font-size: 11px !important;
  color: #6B7280 !important;
  line-height: 1.35;
}

.model-menu-empty {
  font-size: 13px;
  color: #999;
}

.model-menu-footer {
  flex: 0 0 auto;
  min-height: 40px;
}

.reasoning-effort-button-wrapper {
  display: inline-flex;
  align-items: center;
}

.reasoning-effort-trigger {
  box-shadow: none !important;
  min-width: 120px !important;
  width: auto !important;
  height: 36px !important;
  padding: 0 14px !important;
  border-radius: 999px !important;
  flex-shrink: 0;
  background: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 10%, white) !important;
  border: 1px solid color-mix(in srgb, var(--reasoning-tone-color, #64748b) 24%, rgba(15, 23, 42, 0.08)) !important;
}

.reasoning-effort-trigger :deep(.v-btn__overlay) {
  background-color: transparent !important;
}

.reasoning-effort-trigger__content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.reasoning-effort-trigger__icon {
  color: var(--reasoning-tone-color, #64748b);
}

.reasoning-effort-trigger__label {
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  text-transform: none;
  letter-spacing: 0;
  color: var(--reasoning-tone-color, #64748b);
}

.reasoning-effort-trigger__dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--reasoning-tone-color, #64748b);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--reasoning-tone-color, #64748b) 18%, white);
}

.reasoning-effort-trigger:hover,
.reasoning-effort-trigger--active {
  transform: translateY(-1px);
  box-shadow: none !important;
  background-color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 14%, white) !important;
  border-color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 34%, rgba(15, 23, 42, 0.08)) !important;
}

.reasoning-effort-menu {
  width: min(268px, calc(100vw - 24px));
  padding: 10px;
  border-radius: 16px !important;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(250, 250, 250, 0.98));
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.1) !important;
}

.reasoning-effort-menu__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
  padding: 2px 2px 0;
}

.reasoning-effort-menu__title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #0f172a;
}

.reasoning-effort-menu__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  color: var(--reasoning-tone-color, #64748b);
  background: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 10%, white);
  border: 1px solid color-mix(in srgb, var(--reasoning-tone-color, #64748b) 24%, rgba(148, 163, 184, 0.18));
}

.reasoning-effort-menu__options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.reasoning-effort-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  text-align: left;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;
  cursor: pointer;
}

.reasoning-effort-option:hover {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 35%, rgba(148, 163, 184, 0.18));
  background: linear-gradient(180deg, rgba(255, 255, 255, 1), color-mix(in srgb, var(--reasoning-tone-color, #64748b) 4%, white));
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.06);
}

.reasoning-effort-option--active {
  border-color: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 50%, rgba(148, 163, 184, 0.24));
  background: linear-gradient(180deg, color-mix(in srgb, var(--reasoning-tone-color, #64748b) 8%, white), rgba(255, 255, 255, 0.98));
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.07);
}

.reasoning-effort-option__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 10px;
  background: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 10%, white);
  color: var(--reasoning-tone-color, #64748b);
  transition: background 0.18s ease, color 0.18s ease;
}

.reasoning-effort-option--active .reasoning-effort-option__icon {
  background: color-mix(in srgb, var(--reasoning-tone-color, #64748b) 18%, white);
  color: var(--reasoning-tone-color, #64748b);
}

.reasoning-effort-option__copy {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.reasoning-effort-option__label {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.reasoning-effort-option__meta {
  font-size: 11px;
  line-height: 1.3;
  color: #64748b;
}

.reasoning-effort-option__status {
  margin-left: auto;
  flex-shrink: 0;
  color: var(--reasoning-tone-color, #64748b);
}

.attachment-list {
  padding: 4px;
  background: var(--side-bar-bg, linear-gradient(180deg, #FFF 0%, #FFF5F2 100%)) !important;
  min-width: 100px;
}

.attachment-list-item:last-child {
  margin-bottom: 0;
}

.attachment-list-item .v-list-item__prepend {
  margin-right: 12px;
}

.attachment-list-item .v-icon {
  color: #374151;
}

.attachment-title {
  font-weight: 400;
  font-size: 14px;
  color: #171717;
}

/* Responsive Design */
@media (max-width: 768px) {
  .file-attachment {
    width: 280px;
  }

  .file-name {
    font-size: 13px;
  }

  .attachment-list-item {
    padding: 10px 14px;
  }
}

/* Animation for file upload progress */
@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
}

.file-processing {
  animation: pulse 2s infinite;
}

.topic-item {
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.topic-item .topic-menu-btn {
  opacity: 0;
  /* Hide by default */
  transition: opacity 0.2s ease-in-out;
}

.topic-item:hover .topic-menu-btn,
.topic-item.v-list-item--active .topic-menu-btn {
  opacity: 1;
  /* Show on hover or when active */
}

.topic-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topic-item-editing {
  /* Optional: Add specific styles for the editing state if needed */
  background-color: rgba(var(--v-theme-primary), 0.05);
}

.log-toggle-button {
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  width: 35px !important;
  height: 35px !important;
  display: flex !important;
}

.log-toggle-button:hover {
  transform: translateY(-1px) scale(1.05) !important;
}

.log-toggle-button .v-icon {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.log-toggle-button:hover .v-icon {
  transform: scale(1.1) !important;
}

.stream-topic-name .v-input__control {
  width: 100%;
}

.stream-message-box {
  line-break: anywhere;
  position: relative;
  padding: 4px 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  display: flex;
  width: fit-content;
  max-width: 65%;
  margin-top: 25px;
  margin-bottom: 18px;
  border-radius: 24px 0 24px 24px;
  background: #f9eae7;
  backdrop-filter: blur(2px);
  color: #171717;
}

.stream-request-time {
  position: absolute;
  top: -20px;
  font-size: 10px;
  color: rgb(113, 113, 122);
  margin: 0;
  padding: 0;
  background: transparent;
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.stream-param-box {
  background: #f8fafd;
  border-radius: 16px;
  padding: 4px 4px 0px 4px;
  box-shadow: 0 2px 8px rgba(80, 120, 255, 0.04);
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.stream-field-row {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 6px;
}

.stream-field-icon {
  margin-right: 2px;
}

.stream-label {
  font-size: 13px;
  font-weight: 500;
  color: #3b4252;
  min-width: 70px;
  margin-right: 8px;
}

.stream-text-field {
  flex: 1;
  min-width: 0;
  border-radius: 16px !important;
  width: 100%;
}

.modelclass {
  display: flex;
  padding: 15px;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: rgba(56, 89, 208, 0.90);
  color: white;
}

.userrow {
  max-height: 50px !important;
  padding: 8px !important;
  margin: 0 !important;
  border-bottom: 1px solid #e0e0e0;
  background-color: #ffffff;
}

.user-header-title {
  display: flex;
  align-items: center;
}

.user-id-label {
  color: var(--Gray-Text, #646464);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.header-icon-btn {
  width: 36px !important;
  height: 36px !important;
}

.header-icon-btn :deep(.v-icon) {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.header-icon-btn:hover :deep(.v-icon) {
  opacity: 1;
}

.tooltip-content {
  font-size: 12px;
  line-height: 1.5;
}

.tooltip-content p {
  white-space: nowrap;
}

.titlediv {
  border-radius: 12px 12px 0px 0px;
  border-bottom: 0.4px solid var(--Blue-support, #3859d08a);
  background: #E7EBFF;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px !important;
  justify-content: space-between;
}

.labeldiv {
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
}

.modern-input :deep(.v-field) {
  border-radius: 12px !important;
  transition: all 0.2s ease;
}

:deep(.v-text-field .v-input__details) {
  display: none !important;
}

:deep(.v-textarea .v-field) {
  border-radius: 16px !important;
}

.modeldiv {
  border-radius: 16px !important;
  border: 1px solid var(--Gray-Text, #646464);
  padding: 8px 12px;
  margin-bottom: 15px;
}

.chat-input-container {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
}

.clear-chat-btn {
  width: 44px !important;
  height: 44px !important;
  min-width: 44px !important;
  border-radius: 50% !important;
  transition: all 0.2s ease;
  flex-shrink: 0;
  align-self: center;
}

.clear-chat-btn:hover:not(:disabled) {
  background: #E5E7EB !important;
  transform: scale(1.05);
}

.clear-chat-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.main-input-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 12px;
  border: 1px solid var(--Field-border, #C9C9C9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 8px 12px;
  transition: all 0.3s ease;
}

.main-input-wrapper:focus-within {
  border-color: #3B82F6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.file-previews-container {
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
  padding: 8px;
  flex-wrap: wrap;
}

.input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.input-action-btn {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  border-radius: 50% !important;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.input-action-btn:hover:not(:disabled) {
  background: #F3F4F6 !important;
  transform: scale(1.05);
}

.input-action-btn:disabled {
  opacity: 0.4;
}

.message-textarea {
  flex: 1;
  min-width: 0;
}

.message-textarea :deep(.v-field) {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.message-textarea :deep(.v-field__input) {
  padding: 8px 12px;
  min-height: 20px !important;
  font-size: 14px;
}

.message-textarea :deep(.v-field__outline) {
  display: none;
}

.send-stop-btn {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  border-radius: 50% !important;
  background: transparent !important;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease;
}

.send-stop-btn:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.send-stop-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.character-counter {
  display: flex;
  justify-content: flex-end;
  padding: 4px 12px 0;
}

.character-counter span {
  font-size: 11px;
  color: #9CA3AF;
}

/* Responsive */
@media (max-width: 768px) {
  .chat-input-container {
    gap: 8px;
  }

  .clear-chat-btn {
    width: 40px !important;
    height: 40px !important;
  }

  .main-input-wrapper {
    border-radius: 40px;
  }
}

.divider {
  height: 40px;
  border-left: 1px solid rgba(148, 154, 168, 0.50);
}

.headline {
  color: var(--Main-Text, #171717);
  font-size: 20px;
  font-weight: 700;
  line-height: normal;
}

.language :deep(.v-field) {
  border-radius: 16px !important;
}

.language :deep(.v-input__details) {
  display: none !important;
  padding: 0 !important;
  min-height: 0 !important;
}

.textarea-waveform-container {
  flex: 1;
  min-width: 0;
  position: relative;
}

.waveform-recording-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: #F9FAFB;
  border-radius: 12px;
  min-height: 80px;
}

.recording-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px;
}

.recording-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.recording-dot {
  width: 8px;
  height: 8px;
  background: #EF4444;
  border-radius: 50%;
  animation: pulse-recording 1.5s ease-in-out infinite;
}

@keyframes pulse-recording {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

.recording-text {
  font-size: 13px;
  font-weight: 600;
  color: #EF4444;
}

.recording-duration {
  font-size: 13px;
  font-weight: 600;
  color: #6B7280;
  font-family: 'DejaVu Sans Mono', 'Cousine', monospace;
}

.waveform {
  width: 100%;
  min-height: 60px;
  background: white;
  border-radius: 8px;
  padding: 4px 8px;
}

.recording-btn {
  animation: pulse-button 1s ease-in-out infinite;
}

@keyframes pulse-button {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

/* Wavesurfer overrides */
:deep(.waveform > *) {
  overflow: visible !important;
}

:deep(.waveform canvas) {
  border-radius: 4px;
}

/* Topic list wrappers */
.topic-edit-wrapper,
.topic-display-wrapper {
  border-radius: 12px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.topic-display-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.topic-display-active {
  background-color: rgba(56, 89, 208, 0.08) !important;
}

/* Text field for topics */
.topic-input-field :deep(.v-field),
.topic-display-field :deep(.v-field) {
  border-radius: 12px !important;
  background: #FFFFFF !important;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #3859D0 !important;
}

.topic-input-field :deep(.v-field) {
  cursor: text !important;
}

.topic-display-field :deep(.v-field):hover {
  background: #F9FAFB !important;
}

.topic-display-active .topic-display-field :deep(.v-field) {
  border-color: #3859D0 !important;
  background: rgba(56, 89, 208, 0.05) !important;
}

.topic-input-field :deep(.v-field__input),
.topic-display-field :deep(.v-field__input) {
  padding: 10px 8px 10px 14px !important;
  font-size: 14px !important;
  color: #171717 !important;
  cursor: inherit;
  min-height: 40px !important;
}

.topic-display-field :deep(.v-field__input) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Three dots button inside text field */
.topic-dots-btn {
  opacity: 0;
  transition: opacity 0.2s ease;
  width: 24px !important;
  height: 24px !important;
  margin-right: -4px !important;
}

.topic-edit-wrapper:hover .topic-dots-btn,
.topic-display-wrapper:hover .topic-dots-btn,
.topic-display-active .topic-dots-btn {
  opacity: 1;
}

.topic-dots-btn :deep(.v-icon) {
  font-size: 18px;
  color: #6B7280;
}

/* Menu card styling */
.topic-menu-card {
  border-radius: 8px !important;
  border: 1px solid #E5E7EB !important;
  background: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
  min-width: 140px;
}

.topic-menu-list {
  padding: 4px !important;
  background: #FFFFFF !important;
}

.topic-menu-item {
  border-radius: 6px !important;
  margin-bottom: 2px !important;
  padding: 8px 12px !important;
  min-height: 36px !important;
  transition: background-color 0.15s ease;
}

.topic-menu-item:last-child {
  margin-bottom: 0 !important;
}

.topic-menu-item:hover {
  background-color: #F3F4F6 !important;
}

.topic-menu-item-rename {
  background-color: #E8E5FF !important;
}

.topic-menu-item-rename:hover {
  background-color: #D9D4FF !important;
}

.topic-menu-title {
  font-size: 14px;
  font-weight: 400;
  color: #171717;
  line-height: 20px;
}

.vlistdiv {
  background: #f8fafd !important;
}
</style>
